// Reference to the global command queue for asynchronous execution of GPT-related calls.
var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];

// Reference to the global command queue for asynchronous execution of Prebid-related calls.
var pbjs = pbjs || {};
pbjs.que = pbjs.que || [];

// =============================================================================
// 07102026 -- ARM B v3 of the Zena A/B "NON-EEA CONSENT FAST PATH"
// =============================================================================
// Base: 01102026-2/ads-b.js (fast path v1). One functional change: the
// first-screen In_Text_1 auction waits for the REAL consent answer.
//
// Why: on v1 the whole first-screen Prebid dip sat on In_Text_1 (Prebid EUR/1k
// -14%, every other unit flat). In_Text_1 is Teads' unit (~69% of its Prebid
// revenue). Headless captures of 07.10.2026 showed the cause: the fast path's
// synthetic TCF answer carries an EMPTY tcString, while the real CMP answers
// Serbian visitors with gdprApplies=false AND a full TCF string. Teads' user id
// module calls its fpc endpoint with that string; with an empty one it gets no
// id back and deletes its cookie, so the In_Text_1 bid request goes out
// without teadsId and Teads answers with no bid.
//
// What v3 does (IN_TEXT_1 REAL-CONSENT HOLD block, below the telemetry block):
//   - Only when the fast path's synthetic answer is in force at the moment the
//     first-screen auctions are dispatched: In_Text_1 is taken out of the
//     immediate first-screen auction. Billboard, P1 and Sticky leave at once,
//     exactly as on v1 (the speed gain stays).
//   - In_Text_1 waits until Prebid holds the real CMP's consent string (the
//     CMP's real final answer reaches Prebid's own TCF listener through the
//     watchdog proxy), capped at IN_TEXT_1_REAL_CONSENT_MAX_WAIT_MILLISECONDS.
//   - With the real string in place, only the teadsId submodule is refreshed
//     (pbjs.refreshUserIds), and the auction waits for the id, capped at
//     IN_TEXT_1_TEADS_ID_MAX_WAIT_MILLISECONDS.
//   - Then In_Text_1 gets its own Prebid auction and its first GPT request.
//   The wrapper never invents a consent string: when the real answer does not
//   arrive in time, In_Text_1 is auctioned as on v1.
//   Pages without the fast path (EEA, CMP already decided, no stamp) are
//   untouched: In_Text_1 stays in the first-screen batch.
//
// Also: the former country-stamp spelling adsVisitoryCountry is no longer read
// (the head template writes adsVisitorCountry since 01.10.2026).
//
// Kill switch: IN_TEXT_1_REAL_CONSENT_HOLD_ENABLED = false makes this file
// behave as v1. Rollback: CMS PROD_B back to 01102026-2/ads-b.min.js.
// Debugging: window.__zenaInText1Hold.
//
// =============================================================================
// 01102026 -- ARM B of the Zena A/B "NON-EEA CONSENT FAST PATH" (v1 notes)
// =============================================================================
// (01102026-2: same build; the country stamp is read under the head template's
// new name window.adsVisitorCountry as well as the former adsVisitoryCountry,
// so the template rename of 01.10.2026 and this file can land in either order.
// The former spelling is to be dropped in the next build.)
//
// Base: 22092026/ads.js (the single live baseline on both CMS variants:
// web interstitial with Adform demand, first-request telemetry, CMP watchdog).
// Arm A (CMS PROD) stays on that file; this file is arm B (CMS PROD_B).
//
// Why: the 15092026 telemetry showed that consent becoming final is the first
// link of the chain to the first ad request on this site (median ~1.2 s):
// GPT and Prebid's consent module both hold until the TCF API gives a final
// answer, and consentmanager gives this site's Serbian visitors their "GDPR
// does not apply" answer only after its core and configuration have loaded.
// The same mechanism on Pulsonline (30092026 arm B, read 01.10.2026) moved
// pages with the first request at >= 2 s down by 7-8 points and pages at
// >= 3 s by 11 points, with the other countries (no fast path) unchanged and
// money flat.
//
// What this build changes (all inside the TCF CMP WATCHDOG block, plus two
// telemetry lines):
//
//   1. The template now stamps the visitor's edge country on the page
//      (window.adsVisitorCountry, server-side, both variants). When the stamp
//      is RS/BA/ME/MK/XK/AL, the device timezone is not an EEA/CH/UK zone and
//      the CMP's synchronous ping still says "stub" or "loading", the watchdog
//      takes over AT ONCE (at script execution) with the same synthetic "GDPR
//      does not apply" answer it gives during a CMP outage: GPT, Prebid and
//      every other TCF consumer are answered immediately instead of ~1.2 s
//      later. The CMP still loads and decides; its real final answer (or its
//      banner) always reaches every consumer, ends the fast path, and governs
//      from then on. TCF only: GPP stays with the CMP unless the outage
//      detection fires (then the full outage mode applies as before).
//
//   2. The watchdog's proxy becomes an accessor property on window.__tcfapi,
//      so the CMP core's own `window.__tcfapi = ...` assignment no longer
//      takes the proxy out of the loop (consumers registering after the core
//      loaded are covered too); consumers that registered before this file
//      ran are answered through the CMP stub's command queue and the loaded
//      core's registry and re-wrapped in place, so the CMP's non-final
//      "loading" pings never reach a consumer that already holds the final
//      answer.
//
//   3. No recovery refresh in fast-path mode: GPT is answered before this
//      wrapper defines a single slot, so nothing was ever dropped and the
//      wrapper's own first requests must not be pre-empted.
//
//   4. Synthetic GPP answers (outage mode only) follow GPP 1.1: a listener
//      first hears listenerRegistered, removeEventListener answers
//      (true, true), the postMessage path returns a boolean (the Ogury
//      GPP_ERROR_STRING_REMOVE_EVENT_LISTENER_ERROR report of 16.09.2026).
//
//   5. Telemetry: aq_first_request values carry the arm prefix "b_" on this
//      build (arm A sends the bare values), the watchdog records consent
//      final as "fast_path_<country>" when the fast path applied, and
//      window.__zenaTimingSnapshot() carries a copy of the watchdog state.
//
// Kill switch: CONSENT_FAST_PATH_ENABLED = false. Rollback: CMS PROD_B back to
// 22092026/ads.min.js. Read: gam-reporting/run_report_zena_fast_path_ab.py
// (speed per arm, b_ rows), run_report_zena_first_request_telemetry.py
// (aq_consent_wait pooled), run_report_zena_bid_cache_ab.py --launch-date
// 2026-10-01 (money per arm).
//
// Everything else is byte-identical to 22092026/ads.js.
// =============================================================================

// =============================================================================
// 22092026 -- PREBID DEMAND ON THE WEB INTERSTITIAL (Adform placement 2294693)
// =============================================================================
//
// Same change on BOTH CMS variants (PROD = ads.min.js, PROD_B = ads-b.min.js);
// everything each arm did before this release is untouched, so the running
// Billboard A/B keeps reading b vs a exactly as before.
//
// What this release adds:
//
//   1. The wrapper defines the Google web interstitial itself: one GPT
//      out-of-page slot of format INTERSTITIAL on the existing GAM ad unit
//      "/161634325/Zena.rs/Interstitial" (sizes in GAM: 300x250, 320x480,
//      336x280). A web interstitial needs no markup in the page: GPT renders
//      it in its own full-screen container on the visitor's next same-site
//      navigation, under Google's own frequency capping.
//
//   2. The slot gets a Prebid ad unit with ONE bidder: Adform (adf adapter,
//      placement mid 2294693, configured on Adform's side as 300x250). The ad
//      unit carries the OpenRTB interstitial flag (ortb2Imp.instl = 1) for any
//      bidder added later; the adf adapter itself does not forward that flag,
//      Adform knows the format only through the placement configuration.
//      Sizes offered to Prebid: 300x250 + 336x280 on every viewport, plus
//      320x480 (portrait) below 1024 px. 300x250 and 336x280 are placeholder
//      sizes on the hb_pb price-priority line items, which is what makes those
//      line items eligible to serve into this slot.
//
//   3. The interstitial runs its OWN Prebid auction (one requestBids call with
//      just this ad unit, standard PREBID_TIMEOUT) and its OWN GPT request,
//      dispatched right after the first-screen auctions are dispatched. The
//      Billboard, Sticky, P1 and In_Text_1 flows are not touched: no extra ad
//      unit in their auctions, no change to their request order or timing.
//      The creative is only shown on the NEXT navigation, so one auction
//      timeout of delay on this slot costs nothing.
//
//   4. The slot is never refreshed and never observed for viewability: it has
//      no div, and GPT's auto-generated element id for an out-of-page slot
//      contains "/" characters that would make a "#" + id selector throw, so
//      every loop over pubads().getSlots() skips out-of-page slots first.
//      display() is called with the slot object (no element id to display by).
//
//   5. Targeting on the slot: position=Interstitial, refresh_count=0,
//      refresh_bucket=initial (the reporting cuts keep seeing it), the hb_*
//      keys from setTargetingForGPTAsync, and the aq_* auction-quality keys of
//      its own auction (aq_bid_count / aq_bidder_count / aq_top_bid_bucket /
//      aq_timed_out), so GAM can report whether Adform bid and at what price
//      EVEN WHEN the bid loses: the GAM pricing rule on interstitials
//      (EUR 5.00 floor, applied to price-priority line items too) blocks every
//      Prebid bid below that level at the ad server.
//
// Coexistence with GAM's automatic ("codeless") interstitial on this ad unit:
// GPT allows ONE web interstitial per page. When the wrapper can see that GPT
// already holds an interstitial slot on this ad unit path, it defines no second
// slot and runs no interstitial auction, so the page behaves as before. When it
// cannot see it, GPT refuses the wrapper's request (publisher console message
// 134) and the page still behaves as before. The wrapper's slot takes over on
// its own once the codeless unit is switched off in GAM. If GPT refuses the
// slot at definition (null), the wrapper carries on without it.
//
// Kill switch: INTERSTITIAL_PREBID_ENABLED = false reproduces the previous
// build of this arm (no slot, no auction).
//
// Live check: window.__zenaInterstitialState (defined / slotElementId /
// reason / auctionRequested / bidCount / topBidCpm / gptRequested) and the GPT
// request for /161634325/Zena.rs/Interstitial carrying hb_* and aq_* keys.
// =============================================================================

// =============================================================================
// 15092026 -- FIRST-REQUEST TIMING TELEMETRY (passive) + dead bidder cleanup
// =============================================================================
//
// Single build for BOTH CMS variants (PROD and PROD_B). No A/B in this release:
// it only MEASURES, it changes nothing about when or how ads are requested.
//
// Why: on this site every first-screen slot (Billboard, P1, In_Text_1, the
// Sticky) waits for the consent platform before the first ad request can go
// out -- Prebid's consent module holds the auction until the TCF API reports a
// final state, and GPT holds its own request the same way. Measured live on
// Serbian connections that wait is 1.7-3 s, for visitors who never see a
// consent banner because GDPR does not apply to them. Impressions that render
// after the visitor has already scrolled past are the ones that end up
// unviewable, unpaid or never requested at all. Before deciding on a fix
// (answering the TCF query immediately for non-EEA visitors) the size of the
// delay and its cost per bucket must be known from GAM, not estimated.
//
// What this build adds (all passive, all wrapped in try/catch):
//
//   1. Two page-level GPT key-values, set right before the FIRST
//      googletag.pubads().refresh() call on the page and therefore carried by
//      every ad request of the page view:
//
//        aq_first_request  -- milliseconds from the page's time origin
//                             (navigation start) to that first refresh() call,
//                             bucketed: lt_500, 500_999, 1000_1499, 1500_1999,
//                             2000_2999, 3000_4999, 5000_plus, unknown.
//
//        aq_consent_wait   -- milliseconds from the time origin to the moment
//                             consent became FINAL for this page (real TCF
//                             "tcloaded" / "useractioncomplete", a
//                             gdprApplies=false answer, the CMP watchdog's
//                             synthetic answer, or "no CMP on the page"),
//                             same buckets; "pending" when the first ad
//                             request was fired before consent was final. If
//                             consent becomes final later, the page-level
//                             value is updated, so the page's later requests
//                             (lazy slots, refreshes) carry the real number.
//
//      Both keys must exist in GAM as PREDEFINED keys with exactly these
//      values, reportable as custom dimensions (like aq_bidder_count),
//      otherwise GAM drops the rows silently.
//
//   2. window.__zenaTimingSnapshot(): a debug snapshot with the raw
//      milliseconds behind those buckets plus the first GPT slotRequested /
//      slotResponseReceived / slotRenderEnded times per slot, for live checks
//      in the browser (?addebug=1 also logs them).
//
//   3. The TCF CMP watchdog records WHEN consent became final and WHY
//      (watchdogState.consentFinalAtMs / consentFinalReason). The watchdog's
//      behaviour is unchanged; it only takes notes.
//
// Cleanup in the same build: the 42 commented-out connectad and pubmatic
// entries (21 ad units x 2) are removed. Both partners are marked deleted in
// the business HB ID sheet for this site and neither adapter is compiled into
// the Prebid library, so the lines were dead text. Re-adding either bidder is
// a library rebuild plus fresh ids from the sheet, not an uncomment.
//
// Everything else is byte-identical to 13092026-3/ads-a (Equativ through the
// smartadserver adapter, RTB House bidfloor 0.10 kept on all 22 entries).
// =============================================================================


// =============================================================================
// TCF CMP WATCHDOG
// =============================================================================
//
// Background: a consentmanager.net CMP is embedded in this site's templates.
// When its remote configuration fails to load, the CMP answers every TCF query
// with cmpStatus "loading" forever: no banner is rendered, no consent string
// is ever produced, and gdprApplies stays true. GPT and Prebid are both
// consent-aware, so in that state neither of them sends a single ad request
// and every slot on the site goes dark. This happened for real on 03.09.2026
// and cost a full ad outage.
//
// What the failure actually looks like (measured 04.09.2026): the CMP core
// script loads and its first configuration call (/delivery/cmp.php) completes
// normally, but the answer carries no configuration -- the account's designs
// are all geo-targeted and none is marked as fallback, so a visitor whose
// country matches no design gets nothing. On a healthy load the design file
// (/delivery/customdata/...) is requested within a few milliseconds of
// cmp.php finishing; on the broken load nothing ever follows cmp.php.
//
// What this watchdog does:
//
//   1. It wraps window.__tcfapi in a transparent pass-through proxy. While
//      the CMP behaves normally, the proxy changes nothing: every call and
//      every event goes straight through, and consent behavior is entirely
//      the CMP's.
//
//   2. It watches the CMP's own network activity (the design-file <script>
//      element in the DOM, and the browser's resource timeline). If cmp.php
//      has completed and no design file has been requested for
//      CMP_NO_DESIGN_CONFIRM_MILLISECONDS afterwards, the
//      CMP is in the broken state described above and the watchdog takes
//      over. This is a positive detection of the failure, not a timeout, so
//      it fires early (about 2 seconds into the page) for a broken visitor and
//      NEVER fires for a visitor whose CMP is merely slow but progressing.
//
//   3. A visitor for whom the CMP IS progressing (design file requested, or
//      the CMP's own status advanced, or a real "cmpuishown" / "tcloaded"
//      event arrived) is left entirely to the real CMP. That includes EU
//      visitors, who must see the banner and whose ads must wait for their
//      choice. The watchdog stands down for good on any such signal.
//
//   4. As a last resort, if the CMP shows no progress at all for
//      CMP_WATCHDOG_MAX_WAIT_MILLISECONDS (its scripts never loaded, the
//      vendor is entirely unreachable), the watchdog also takes over, so a
//      genuine vendor outage still cannot black out the site for the
//      non-EEA audience.
//
//   5. Before taking over it checks the visitor's device timezone. A device
//      set to an unambiguously EEA/CH/UK timezone (Berlin, Vienna, Zurich,
//      Paris, ...) is never answered synthetically: for that visitor the
//      watchdog does nothing, and if the CMP cannot serve them they get no
//      ads rather than ads without consent. Timezones that Serbian devices
//      commonly report (the Windows "Belgrade, Bratislava, Budapest,
//      Ljubljana, Prague" group maps to Europe/Budapest on many machines)
//      are deliberately NOT on that list, so a Serbian visitor is never
//      denied ads by this check. It is a fail-safe, not a geo lookup.
//
//   6. On takeover, every TCF consumer that registered through the proxy
//      (GPT, Prebid) immediately receives a synthetic final answer with
//      gdprApplies = false, and every later TCF call is answered the same
//      way. gdprApplies = false is the correct resolution for this site's
//      overwhelmingly Serbian (non-EEA) audience and is exactly how the
//      working consentmanager instances on this network resolve for them.
//
//   7. It is self-healing in both directions. If the account is fixed, the
//      design file arrives on every load and the watchdog never fires. If the
//      real CMP asserts itself after a takeover (a genuine "cmpuishown" or
//      final event), the proxy returns to pass-through, the synthetic answers
//      stop, and the GPT recovery refresh is never issued.
//
// Known limitation, accepted: a consumer that registered its listener
// directly with the broken CMP BEFORE this wrapper executed cannot be
// notified through the proxy; the consentmanager registry rescue below
// covers that case for this vendor specifically.
//
// Debugging: window.__cmpWatchdog exposes
// { wrapped, takenOver, cmpFinal, cmpHealthy, takeoverReason, timezone, timezoneBlocked }.

// After the CMP's configuration call (cmp.php) has completed, how long to wait
// for the design file request before concluding the configuration was empty.
// On a healthy load the design file follows within ~10 ms; 750 ms is a very
// wide margin.
var CMP_NO_DESIGN_CONFIRM_MILLISECONDS = 750;

// Absolute ceiling: if the CMP has shown no progress of any kind for this
// long after the proxy was installed, take over anyway (vendor unreachable).
// Generous on purpose: an EU visitor on a slow connection may need several
// seconds just for cmp.php (measured 2.6 s from Germany), and taking over
// before that would bypass their banner. Serbian visitors on the broken
// instance are not affected by this value at all -- their takeover comes from
// the empty-configuration signature at ~2 s.
var CMP_WATCHDOG_MAX_WAIT_MILLISECONDS = 8000;

// How often the watchdog re-evaluates the CMP's progress.
var CMP_WATCHDOG_POLL_MILLISECONDS = 250;

// Device timezones that identify an EEA/CH/UK visitor beyond reasonable doubt.
// The synthetic "GDPR does not apply" answer is never given to these. The
// list intentionally omits every zone a Serbian device might report:
// Europe/Belgrade itself, and the Windows group-default zones Europe/Budapest
// (Belgrade/Bratislava/Budapest/Ljubljana/Prague group) and Europe/Warsaw
// (Sarajevo/Skopje/Warsaw/Zagreb group), plus Prague, Bratislava, Ljubljana
// and Zagreb which share those groups.
var CMP_WATCHDOG_EEA_DEVICE_TIMEZONES = [
    'Europe/Berlin', 'Europe/Vienna', 'Europe/Zurich', 'Europe/Amsterdam',
    'Europe/Brussels', 'Europe/Luxembourg', 'Europe/Paris', 'Europe/Madrid',
    'Europe/Rome', 'Europe/Malta', 'Europe/Copenhagen', 'Europe/Stockholm',
    'Europe/Oslo', 'Europe/Helsinki', 'Europe/Athens', 'Europe/Bucharest',
    'Europe/Sofia', 'Europe/Vilnius', 'Europe/Riga', 'Europe/Tallinn',
    'Europe/Dublin', 'Europe/London', 'Europe/Lisbon', 'Atlantic/Reykjavik',
    'Atlantic/Madeira', 'Atlantic/Azores', 'Atlantic/Canary', 'Europe/Nicosia',
    'Asia/Nicosia', 'Europe/Vaduz'
];

// The CMP stub is normally installed by the template before this file runs,
// but load order is not guaranteed. If window.__tcfapi is not there yet, the
// watchdog polls for it this often, for at most this long, then gives up
// (no CMP on the page means nothing blocks ad serving and there is nothing
// to guard).
var CMP_APPEARANCE_POLL_MILLISECONDS = 200;
var CMP_APPEARANCE_MAX_WAIT_MILLISECONDS = 10000;

// =============================================================================
// NON-EEA CONSENT FAST PATH (01102026, arm B) -- lives inside the watchdog
// =============================================================================
//
// Why: GPT and Prebid's consent module both hold until the TCF API gives a
// final answer, and consentmanager gives this site's Serbian visitors their
// "GDPR does not apply" answer only after its own core and configuration have
// loaded (about 1.5 s median on phones). The Puls A/B of 30.09.2026 showed
// that answering that question at script execution for stamped non-EEA
// visitors moves the first ad request left by 7-8 points of pages at >= 2 s.
//
// How: the template stamps the visitor's edge country on the page
// (window.adsVisitorCountry, server-side geo, both variants). When the stamp
// is one of the countries below, the device timezone is not an EEA/CH/UK
// zone, and the CMP's synchronous ping still says "stub" or "loading", the
// watchdog takes over AT ONCE with exactly the synthetic "GDPR does not apply"
// answer it already uses for a CMP outage: every TCF consumer (GPT, Prebid,
// vendors) is answered immediately, consumers that registered before this
// file ran are answered through the stub queue and the CMP registry, and the
// proxy stays in front of window.__tcfapi as an accessor property so the CMP
// core's own `window.__tcfapi = ...` assignment cannot drop it. The CMP still
// loads and decides: its real final answer (or its banner) always reaches
// every consumer, ends the fast path, and governs from then on. The fast path
// touches TCF only; GPP stays with the CMP unless the outage detection fires.
//
// Compliance guards, in this order: the strict country allow-list below, the
// EEA device-timezone veto (CMP_WATCHDOG_EEA_DEVICE_TIMEZONES), and the CMP's
// own answer superseding the synthetic one. A wrong stamp therefore costs the
// visitor nothing: the banner shows, the user decides, ads follow the decision.
//
// Kill switch: CONSENT_FAST_PATH_ENABLED = false rebuilds this arm as the plain
// 22092026 watchdog. Debugging: window.__cmpWatchdog.fastPath* fields and
// window.__zenaTimingSnapshot().watchdog.

var CONSENT_FAST_PATH_ENABLED = true;

// Globals the template may set with the visitor's two-letter edge country, in
// the order they are tried. The head template writes window.adsVisitorCountry
// (renamed on 01.10.2026 from adsVisitoryCountry; the former spelling is no
// longer read since 07102026).
var CONSENT_FAST_PATH_COUNTRY_GLOBALS = ['adsVisitorCountry'];

// Countries answered synthetically: Serbia and the neighbours with the same
// policy. Nothing else, ever (an EEA code or an unknown value is left to the
// CMP).
var CONSENT_FAST_PATH_COUNTRIES = ['RS', 'BA', 'ME', 'MK', 'XK', 'AL'];

// After a fast-path takeover: how often to look for consumers that registered
// straight with the CMP (stub queue / core registry) and to put the proxy
// back if the property was redefined, and for how long at most.
var CONSENT_FAST_PATH_RESCUE_POLL_MILLISECONDS = 100;
var CONSENT_FAST_PATH_RESCUE_MAX_MILLISECONDS = 8000;

(function installCmpWatchdog() {

    // Read-only state for debugging from the console / remote sessions.
    var watchdogState = {
        wrapped: false,
        takenOver: false,
        cmpFinal: false,
        cmpHealthy: false,
        takeoverReason: null,
        timezone: null,
        timezoneBlocked: false,
        // 15092026 telemetry notes: when (ms since the page's time origin) and
        // why consent became final for this page. Set once, never overwritten.
        // Reasons: cmp_tcloaded, cmp_useractioncomplete, gdpr_not_applicable,
        // watchdog, no_cmp.
        consentFinalAtMs: null,
        consentFinalReason: null,
        // 01102026 consent fast path. fastPath is true once its synthetic
        // answers were issued; fastPathSkippedReason says why it did not apply
        // (disabled, no_stamp, unusable_stamp, country_not_listed:XX,
        // eea_device_timezone:Zone, cmp_already_decided, ping_unanswered,
        // cmp_already_loaded, error:...). The counters are live-check aids.
        fastPath: false,
        fastPathSkippedReason: null,
        fastPathStamp: null,
        fastPathCountry: null,
        fastPathAppliedAtMs: null,
        fastPathCmpStatusAtInstall: null,
        fastPathQueuedListenersAnswered: 0,
        fastPathProxiedListenersAnswered: 0,
        // The proxy is an accessor on window.__tcfapi; cmpReplacements counts
        // the CMP core's own assignments the setter captured, rewraps counts
        // outright redefinitions the poll put the proxy back in front of.
        accessorInstalled: false,
        cmpReplacements: 0,
        rewraps: 0,
        // GPP synthetic answers are in force only after an OUTAGE takeover
        // (or the outage escalation after a fast-path takeover), never for the
        // fast path alone.
        gppTakenOver: false,
        outageDuringFastPath: false
    };
    window.__cmpWatchdog = watchdogState;

    // Records the first moment consent stopped blocking ad requests. Passive:
    // nothing in the watchdog reads these two fields back.
    function recordConsentFinal(reason) {
        if (watchdogState.consentFinalAtMs !== null) {
            return;
        }
        watchdogState.consentFinalAtMs = millisecondsSincePageStart();
        watchdogState.consentFinalReason = reason;
        logWatchdog('consent final at ' + Math.round(watchdogState.consentFinalAtMs) + 'ms (' + reason + ').');
    }

    // The CMP's own __tcfapi function once the proxy is installed.
    var realTcfApi = null;

    // Every listener registered through the proxy, so the watchdog can answer
    // them itself on takeover. Each entry is { callback, syntheticListenerId }.
    var proxiedListeners = [];

    // Synthetic listener ids start high so they can never collide with ids
    // handed out by the real CMP.
    var nextSyntheticListenerId = 100000;

    // The progress poll timer, and when the proxy was installed (poll clock).
    var progressPollTimer = null;
    var proxyInstalledAtMilliseconds = 0;

    // The fast path's rescue poll timer (see startFastPathRescuePoll).
    var fastPathRescuePollTimer = null;

    // Consumer callbacks already answered through the CMP stub's command queue,
    // so a repeated queue pass never answers the same consumer twice.
    var answeredQueueCallbacks = [];

    // The proxy function itself, kept here so the accessor getter and the
    // re-wrap check can refer to it.
    var proxiedTcfApiFunction = null;

    function logWatchdog(message) {
        try {
            console.log('[ads.js CMP watchdog] ' + message);
        } catch (ignored) {}
    }

    function nowMilliseconds() {
        return new Date().getTime();
    }

    // True while the watchdog's synthetic answers are in force: it has taken
    // over AND the real CMP has neither finished nor asserted itself since.
    function syntheticAnswersActive() {
        return watchdogState.takenOver && !watchdogState.cmpFinal && !watchdogState.cmpHealthy;
    }

    // True while the watchdog's synthetic GPP answers are in force: only after
    // an outage takeover (or the outage escalation during a fast path). The
    // fast path alone leaves GPP to the CMP.
    function gppSyntheticAnswersActive() {
        return watchdogState.gppTakenOver && !watchdogState.cmpFinal && !watchdogState.cmpHealthy;
    }

    // -------------------------------------------------------------------------
    // Device timezone fail-safe (see point 5 in the header comment).
    // -------------------------------------------------------------------------
    function readDeviceTimezone() {
        try {
            var intlObject = window.Intl || (typeof Intl !== 'undefined' ? Intl : null);
            if (!intlObject || typeof intlObject.DateTimeFormat !== 'function') {
                return null;
            }
            var resolved = intlObject.DateTimeFormat().resolvedOptions();
            if (resolved && typeof resolved.timeZone === 'string' && resolved.timeZone.length > 0) {
                return resolved.timeZone;
            }
        } catch (timezoneError) {
            return null;
        }
        return null;
    }

    function deviceLooksEea() {
        var timezone = readDeviceTimezone();
        watchdogState.timezone = timezone;
        if (timezone === null) {
            // Unknown timezone (very old browser): cannot tell, do not block.
            return false;
        }
        var zoneIndex;
        for (zoneIndex = 0; zoneIndex < CMP_WATCHDOG_EEA_DEVICE_TIMEZONES.length; zoneIndex++) {
            if (CMP_WATCHDOG_EEA_DEVICE_TIMEZONES[zoneIndex] === timezone) {
                return true;
            }
        }
        return false;
    }

    // -------------------------------------------------------------------------
    // CMP progress detection through the resource timeline and the CMP's own
    // public state (see points 2-4 in the header comment).
    // -------------------------------------------------------------------------

    // Returns { configCallCompletedAt: ms-since-page-start or null,
    //           designFileRequested: bool }.
    //
    // The design file is requested by the CMP core as an async <script>
    // element appended to the document the moment cmp.php has executed
    // (measured: 2 ms later). Its download can take several seconds on a slow
    // connection, and a resource-timeline entry only exists once a download
    // has COMPLETED -- so an in-flight design file is invisible in the
    // timeline. The DOM is therefore checked first: a <script> whose src is a
    // consentmanager /delivery/customdata/ URL means the configuration
    // arrived and a design is being fetched, i.e. the CMP is working for this
    // visitor, whether or not the file has finished downloading yet.
    function inspectCmpNetworkActivity() {
        var result = { configCallCompletedAt: null, designFileRequested: false };
        try {
            var scriptElements = document.getElementsByTagName('script');
            var scriptIndex;
            for (scriptIndex = 0; scriptIndex < scriptElements.length; scriptIndex++) {
                var scriptSource = String(scriptElements[scriptIndex].src || '');
                if (scriptSource.indexOf('consentmanager') !== -1 && scriptSource.indexOf('/delivery/customdata/') !== -1) {
                    result.designFileRequested = true;
                    break;
                }
            }
        } catch (domError) {
            // fall through to the timeline check
        }
        try {
            if (!window.performance || typeof window.performance.getEntriesByType !== 'function') {
                return result;
            }
            var resourceEntries = window.performance.getEntriesByType('resource');
            var entryIndex;
            for (entryIndex = 0; entryIndex < resourceEntries.length; entryIndex++) {
                var resourceName = String(resourceEntries[entryIndex].name);
                if (resourceName.indexOf('consentmanager') === -1) {
                    continue;
                }
                if (resourceName.indexOf('/delivery/cmp.php') !== -1) {
                    // responseEnd is exposed for cross-origin resources even
                    // without Timing-Allow-Origin; a still-in-flight request
                    // does not appear in the timeline at all.
                    var responseEnd = resourceEntries[entryIndex].responseEnd;
                    if (typeof responseEnd === 'number' && responseEnd > 0) {
                        if (result.configCallCompletedAt === null || responseEnd < result.configCallCompletedAt) {
                            result.configCallCompletedAt = responseEnd;
                        }
                    }
                }
                if (resourceName.indexOf('/delivery/customdata/') !== -1 || resourceName.indexOf('/delivery/info/') !== -1) {
                    result.designFileRequested = true;
                }
            }
        } catch (performanceError) {
            return result;
        }
        return result;
    }

    // The consentmanager core exposes window.cmpmngr.status: it stays at 1 in
    // the broken state and advances (4 = banner shown, 6 = finished) once the
    // configuration has arrived. Any advance beyond 1 is progress.
    function cmpVendorStatusAdvanced() {
        try {
            var cmpVendorObject = window.cmpmngr;
            if (cmpVendorObject && typeof cmpVendorObject.status === 'number' && cmpVendorObject.status > 1) {
                return true;
            }
        } catch (statusError) {
            return false;
        }
        return false;
    }

    // Milliseconds since the page's time origin, on the same clock as the
    // resource timeline entries.
    function millisecondsSincePageStart() {
        try {
            if (window.performance && typeof window.performance.now === 'function') {
                return window.performance.now();
            }
        } catch (performanceError) {
            return 0;
        }
        return 0;
    }

    // Marks the CMP as genuinely working for this visitor and stands the
    // watchdog down permanently. Called on any progress signal.
    function markCmpHealthy(reason) {
        if (watchdogState.cmpHealthy) {
            return;
        }
        watchdogState.cmpHealthy = true;
        stopProgressPoll();
        if (watchdogState.takenOver) {
            logWatchdog('real CMP asserted itself after a takeover (' + reason + '); synthetic answers withdrawn, proxy back to pass-through.');
        } else {
            logWatchdog('CMP is progressing on its own (' + reason + '); watchdog stood down.');
        }
    }

    function stopProgressPoll() {
        if (progressPollTimer !== null) {
            clearInterval(progressPollTimer);
            progressPollTimer = null;
        }
    }

    // One evaluation of the CMP's progress; runs every
    // CMP_WATCHDOG_POLL_MILLISECONDS until a decision is reached.
    function evaluateCmpProgress() {
        // Nothing left to decide once the CMP is final or healthy, after an
        // outage takeover, or once the fast path escalated to the GPP takeover.
        // A fast-path takeover alone keeps this poll running: TCF is answered,
        // but a CMP that then turns out to be broken still needs the GPP
        // takeover and the GPT re-check (the 03.09.2026 outage mode).
        if (watchdogState.cmpFinal || watchdogState.cmpHealthy || watchdogState.gppTakenOver ||
            (watchdogState.takenOver && !watchdogState.fastPath)) {
            stopProgressPoll();
            return;
        }

        if (cmpVendorStatusAdvanced()) {
            if (watchdogState.fastPath) {
                // The CMP is working; its real answer will end the fast path
                // when it arrives. Only the outage watch stops here.
                stopProgressPoll();
                logWatchdog('CMP is progressing (cmpmngr.status advanced past 1); fast path stays in force until its final answer.');
                return;
            }
            markCmpHealthy('cmpmngr.status advanced past 1');
            return;
        }

        var networkActivity = inspectCmpNetworkActivity();
        if (networkActivity.designFileRequested) {
            if (watchdogState.fastPath) {
                stopProgressPoll();
                logWatchdog('CMP is progressing (design file requested); fast path stays in force until its final answer.');
                return;
            }
            markCmpHealthy('design file requested');
            return;
        }

        var elapsedSinceInstall = nowMilliseconds() - proxyInstalledAtMilliseconds;

        if (networkActivity.configCallCompletedAt !== null) {
            var sinceConfigCall = millisecondsSincePageStart() - networkActivity.configCallCompletedAt;
            if (sinceConfigCall >= CMP_NO_DESIGN_CONFIRM_MILLISECONDS) {
                takeOverOrEscalate('cmp.php completed ' + Math.round(sinceConfigCall) + 'ms ago and no design file followed (empty configuration for this visitor)');
                return;
            }
        }

        if (elapsedSinceInstall >= CMP_WATCHDOG_MAX_WAIT_MILLISECONDS) {
            takeOverOrEscalate('no CMP progress of any kind within ' + CMP_WATCHDOG_MAX_WAIT_MILLISECONDS + 'ms (vendor unreachable)');
            return;
        }
    }

    // A minimal but complete TCData object representing "GDPR does not apply".
    // Consumers only read gdprApplies/eventStatus/cmpStatus in this case, but
    // the usual containers are present so nothing trips over a missing field.
    function buildSyntheticTcData() {
        return {
            // Marker so the watchdog's own observers can tell a synthetic
            // answer from a genuine CMP recovery; harmless extra field for
            // every other TCF consumer.
            syntheticWatchdogAnswer: true,
            tcString: '',
            tcfPolicyVersion: 4,
            cmpId: 31,
            cmpVersion: 1,
            gdprApplies: false,
            eventStatus: 'tcloaded',
            cmpStatus: 'loaded',
            isServiceSpecific: true,
            useNonStandardTexts: false,
            publisherCC: 'RS',
            purposeOneTreatment: false,
            listenerId: null,
            purpose: { consents: {}, legitimateInterests: {} },
            vendor: { consents: {}, legitimateInterests: {} },
            specialFeatureOptins: {},
            publisher: {
                consents: {},
                legitimateInterests: {},
                customPurpose: { consents: {}, legitimateInterests: {} },
                restrictions: {}
            }
        };
    }

    function answerListenerSynthetically(listenerEntry) {
        var syntheticData = buildSyntheticTcData();
        syntheticData.listenerId = listenerEntry.syntheticListenerId;
        try {
            listenerEntry.callback(syntheticData, true);
        } catch (listenerError) {
            logWatchdog('a TCF listener threw while receiving the synthetic answer: ' + listenerError);
        }
    }

    // After a takeover, the proxy can only answer consumers that registered
    // THROUGH it. A consumer that registered before this file executed (GPT's
    // pubads implementation wins that race on some page loads) left its
    // callback inside the real CMP's own registry, forever waiting -- the
    // proxy cannot reach it. For the consentmanager CMP specifically, that
    // registry is publicly reachable at window.cmpmngr.api.events as entries
    // of shape { type: 'tcfv2', listener: function, id: number }, so the
    // watchdog answers those held listeners directly as well. Every step is
    // guarded: any unexpected shape (different CMP vendor, changed internals
    // after a consentmanager update) simply skips the rescue and the proxy
    // path still covers consumers that registered normally. A consumer that
    // registered through the proxy also appears in this registry and will
    // receive the synthetic answer twice; TCF listeners are event streams and
    // both GPT and Prebid handle a repeated final event idempotently.
    // Registry entries already answered, keyed by the CMP's own listener id, so
    // retries never answer the same consumer twice.
    var rescuedRegistryIds = {};

    // Wraps a consumer callback so the CMP's later events reach it through the
    // watchdog's filter: real progress and final states are observed first,
    // and while synthetic answers are in force the CMP's non-final "loading"
    // pings are swallowed (the consumer already holds a final answer; a
    // "loading" ping would only make it wait again). The wrapper is what the
    // real CMP holds from then on. Flagged so the queue and registry passes
    // never mistake it for a new consumer.
    function buildTcfForwarder(listenerEntry) {
        var forwarder = function watchdogTcfForwarder(tcData, success) {
            observeRealEvent(tcData);
            try {
                if (tcData && typeof tcData === 'object' && typeof tcData.listenerId === 'number' && tcData.syntheticWatchdogAnswer !== true) {
                    listenerEntry.realListenerId = tcData.listenerId;
                }
            } catch (idError) {
                // ignore: the real id is only needed for removeEventListener mapping
            }
            if (syntheticAnswersActive()) {
                return;
            }
            listenerEntry.callback(tcData, success);
        };
        forwarder.watchdogTcfForwarder = true;
        return forwarder;
    }

    function findProxiedListener(callback) {
        var index;
        for (index = 0; index < proxiedListeners.length; index++) {
            if (proxiedListeners[index].callback === callback) {
                return proxiedListeners[index];
            }
        }
        return null;
    }

    // Registers a consumer that was found waiting inside the CMP (stub queue
    // or core registry): answered synthetically once, remembered in
    // proxiedListeners so removeEventListener by synthetic id works, and
    // handed back so the caller can re-wrap the CMP's reference in place.
    function adoptWaitingListener(callback, realListenerId) {
        var listenerEntry = {
            callback: callback,
            syntheticListenerId: nextSyntheticListenerId,
            realListenerId: typeof realListenerId === 'number' ? realListenerId : null
        };
        nextSyntheticListenerId = nextSyntheticListenerId + 1;
        proxiedListeners.push(listenerEntry);
        answerListenerSynthetically(listenerEntry);
        return listenerEntry;
    }

    function rescueCmpHeldListeners() {
        var rescuedCount = 0;
        try {
            var cmpVendorObject = window.cmpmngr;
            if (!cmpVendorObject || !cmpVendorObject.api || !cmpVendorObject.api.events || typeof cmpVendorObject.api.events.forEach !== 'function') {
                return 0;
            }
            cmpVendorObject.api.events.forEach(function (registryEntry) {
                if (!registryEntry || registryEntry.type !== 'tcfv2' || typeof registryEntry.listener !== 'function') {
                    return;
                }
                // Consumers that registered through the proxy already sit in
                // the registry as forwarders; nothing to do for them.
                if (registryEntry.listener.watchdogTcfForwarder === true) {
                    return;
                }
                if (rescuedRegistryIds[registryEntry.id] === true) {
                    return;
                }
                rescuedRegistryIds[registryEntry.id] = true;
                if (findProxiedListener(registryEntry.listener) !== null) {
                    return;
                }
                var adoptedEntry = adoptWaitingListener(registryEntry.listener, registryEntry.id);
                rescuedCount = rescuedCount + 1;
                // Re-wrap in place: from now on the CMP's events reach this
                // consumer through the filter above.
                try {
                    registryEntry.listener = buildTcfForwarder(adoptedEntry);
                } catch (rewrapError) {
                    // A frozen registry entry simply keeps the original listener.
                }
            });
        } catch (rescueError) {
            logWatchdog('CMP-held listener rescue skipped: ' + rescueError);
        }
        return rescuedCount;
    }

    // Consumers that registered BEFORE this file ran while the CMP core had
    // not loaded yet are waiting in the CMP stub's command queue
    // (window.__cmp.a, entries shaped ['addEventListener', 2, callback]; the
    // stub also hands the queue back when called with no arguments). Each
    // addEventListener entry is answered synthetically once and re-wrapped in
    // place, so the core registers the forwarder when it drains the queue; a
    // queued one-shot getTCData is answered now (the core answers it for real
    // later, which is the answer that should win anyway). Any unexpected
    // shape just skips the pass; the proxy still covers every consumer that
    // registers from now on.
    function rescueStubQueueListeners() {
        var answeredCount = 0;
        try {
            var commandQueue = null;
            if (window.__cmp && Object.prototype.toString.call(window.__cmp.a) === '[object Array]') {
                commandQueue = window.__cmp.a;
            } else if (typeof realTcfApi === 'function') {
                var returnedQueue = realTcfApi();
                if (Object.prototype.toString.call(returnedQueue) === '[object Array]') {
                    commandQueue = returnedQueue;
                }
            }
            if (commandQueue === null) {
                return 0;
            }
            var queueIndex;
            for (queueIndex = 0; queueIndex < commandQueue.length; queueIndex++) {
                var queuedCall = commandQueue[queueIndex];
                if (!queuedCall || typeof queuedCall.length !== 'number' || queuedCall.length < 3) {
                    continue;
                }
                var queuedCommand = queuedCall[0];
                var queuedVersion = queuedCall[1];
                var queuedCallback = queuedCall[2];
                if (typeof queuedCallback !== 'function' || queuedCallback.watchdogTcfForwarder === true) {
                    continue;
                }
                if (!(queuedVersion === 2 || queuedVersion === '2')) {
                    continue;
                }
                if (answeredQueueCallbacks.indexOf(queuedCallback) !== -1 || findProxiedListener(queuedCallback) !== null) {
                    continue;
                }
                if (queuedCommand === 'addEventListener') {
                    answeredQueueCallbacks.push(queuedCallback);
                    var queuedEntry = adoptWaitingListener(queuedCallback, null);
                    queuedCall[2] = buildTcfForwarder(queuedEntry);
                    answeredCount = answeredCount + 1;
                } else if (queuedCommand === 'getTCData') {
                    answeredQueueCallbacks.push(queuedCallback);
                    try {
                        queuedCallback(buildSyntheticTcData(), true);
                    } catch (callbackError) {
                        logWatchdog('a queued getTCData consumer threw while receiving the synthetic answer: ' + callbackError);
                    }
                    answeredCount = answeredCount + 1;
                }
            }
        } catch (queueError) {
            logWatchdog('stub queue pass skipped: ' + queueError);
        }
        return answeredCount;
    }

    // The registry (window.cmpmngr) belongs to the CMP's full code, which loads
    // over the network and can appear AFTER the takeover fired -- and consumers
    // held in the CMP's stub queue only land in the registry when that code
    // processes the queue. A single rescue pass at takeover therefore misses
    // late arrivals (verified live on 03.09.2026: same build freed GPT on one
    // site and missed it on the other purely by load timing). So the rescue
    // repeats every second for a while after takeover, answering each newly
    // appeared captive listener exactly once, and stops early if the CMP
    // genuinely recovers or asserts itself.
    var CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS = 1000;
    var CMP_RESCUE_MAX_DURATION_MILLISECONDS = 30000;


    // Ad requests that GPT attempted WHILE it was still consent-blocked are
    // dropped, not queued -- freeing GPT afterwards does not resend them
    // (verified live on 03.09.2026: one site's request timing landed after the
    // rescue and rendered, the other site's landed before it and stayed blank
    // with zero gampad requests). So after the first rescue pass that actually
    // freed listeners, wait a moment and check whether ANY ad request has left
    // the page; if none has, issue a single recovery refresh of all GPT slots.
    // The completed Prebid auctions' targeting is already set on the slots, so
    // the recovery request serves with full header-bidding competition.
    // Never issued once the real CMP has asserted itself: for that visitor
    // ad requests must wait for the real consent outcome.
    var gptRedispatchScheduled = false;

    function scheduleGptRedispatchIfSilent() {
        if (gptRedispatchScheduled) {
            return;
        }
        // Fast path alone: GPT was answered at script start, before this
        // wrapper defined a single slot, so no ad request was ever dropped
        // and the wrapper's own first requests must not be pre-empted by a
        // blanket refresh. Only an outage escalation re-arms this check.
        if (watchdogState.fastPath && !watchdogState.gppTakenOver) {
            return;
        }
        gptRedispatchScheduled = true;
        setTimeout(function () {
            try {
                if (!syntheticAnswersActive()) {
                    logWatchdog('real CMP is in charge; recovery refresh not issued.');
                    return;
                }
                var observedAdRequestCount = 0;
                try {
                    var resourceEntries = [];
                    if (window.performance && typeof window.performance.getEntriesByType === 'function') {
                        resourceEntries = window.performance.getEntriesByType('resource');
                    }
                    var entryIndex;
                    for (entryIndex = 0; entryIndex < resourceEntries.length; entryIndex++) {
                        if (String(resourceEntries[entryIndex].name).indexOf('gampad/ads') !== -1) {
                            observedAdRequestCount = observedAdRequestCount + 1;
                        }
                    }
                } catch (performanceError) {
                    observedAdRequestCount = 0;
                }
                if (observedAdRequestCount > 0) {
                    logWatchdog('GPT already dispatched ' + observedAdRequestCount + ' ad request(s); no recovery refresh needed.');
                    return;
                }
                if (window.googletag && window.googletag.cmd) {
                    window.googletag.cmd.push(function () {
                        window.googletag.pubads().refresh();
                    });
                    logWatchdog('GPT sent no ad requests while consent was blocked; issued a one-time recovery refresh of all slots.');
                }
            } catch (redispatchError) {
                logWatchdog('GPT recovery refresh skipped: ' + redispatchError);
            }
        }, 1500);
    }

    // One rescue pass: TCF registry always, GPP registry only once GPP was
    // taken over (an outage; the fast path alone leaves GPP to the CMP).
    function rescuePassForTakeover() {
        var passCount = rescueCmpHeldListeners();
        if (watchdogState.gppTakenOver) {
            passCount = passCount + rescueGppRegistryListeners();
        }
        return passCount;
    }

    function startCmpRegistryRescueLoop() {
        var firstPassCount = rescuePassForTakeover();
        if (firstPassCount > 0) {
            logWatchdog('rescued ' + firstPassCount + ' listener(s) held inside the CMP registry (consumers that registered before this file executed).');
            scheduleGptRedispatchIfSilent();
        }
        var elapsedMilliseconds = 0;
        var rescueTimer = setInterval(function () {
            if (!syntheticAnswersActive()) {
                clearInterval(rescueTimer);
                return;
            }
            var passCount = rescuePassForTakeover();
            if (passCount > 0) {
                logWatchdog('rescued ' + passCount + ' more CMP-held listener(s) on a retry pass.');
                scheduleGptRedispatchIfSilent();
            }
            elapsedMilliseconds = elapsedMilliseconds + CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS;
            if (elapsedMilliseconds >= CMP_RESCUE_MAX_DURATION_MILLISECONDS) {
                clearInterval(rescueTimer);
            }
        }, CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS);
    }

    // Marks the CMP as finished and stands the watchdog down. Called whenever a
    // real final event is observed through the proxy.
    function markCmpFinal(eventStatus) {
        // Telemetry note first: a repeated final event must not re-record.
        recordConsentFinal('cmp_' + (eventStatus || 'final'));
        if (watchdogState.cmpFinal) {
            return;
        }
        watchdogState.cmpFinal = true;
        stopProgressPoll();
        logWatchdog('CMP reached a final state on its own; watchdog stood down.');
    }

    function takeOver(reason) {
        if (watchdogState.takenOver || watchdogState.cmpFinal || watchdogState.cmpHealthy) {
            return;
        }
        stopProgressPoll();

        // Fail-safe: never bypass consent for a device that is clearly in the
        // EEA. For that visitor the watchdog does nothing at all.
        if (deviceLooksEea()) {
            watchdogState.timezoneBlocked = true;
            logWatchdog('CMP looks broken (' + reason + ') but the device timezone is ' + watchdogState.timezone +
                ' (EEA); leaving consent to the real CMP, no synthetic answer for this visitor.');
            return;
        }

        watchdogState.takenOver = true;
        watchdogState.takeoverReason = reason;
        // From this moment every consumer gets gdprApplies=false, so ad
        // requests are no longer blocked by consent (telemetry note).
        recordConsentFinal('watchdog');
        logWatchdog(
            'taking over: ' + reason + '; answering ' + proxiedListeners.length +
            ' registered TCF listener(s) with gdprApplies=false so ad serving can proceed.');
        var listenerIndex;
        for (listenerIndex = 0; listenerIndex < proxiedListeners.length; listenerIndex++) {
            answerListenerSynthetically(proxiedListeners[listenerIndex]);
        }
        // An outage takeover frees GPP as well (GPT consults both signals).
        watchdogState.gppTakenOver = true;
        takeOverGpp();
        startCmpRegistryRescueLoop();
    }

    // The broken-CMP signature after a fast-path takeover: TCF is already
    // answered, so only the GPP takeover and the GPT re-check are still
    // missing. Everything else of the outage mode applies unchanged.
    function escalateOutageDuringFastPath(reason) {
        if (watchdogState.gppTakenOver || watchdogState.cmpFinal || watchdogState.cmpHealthy) {
            return;
        }
        stopProgressPoll();
        watchdogState.outageDuringFastPath = true;
        watchdogState.gppTakenOver = true;
        watchdogState.takeoverReason = watchdogState.takeoverReason + '; CMP outage: ' + reason;
        logWatchdog('CMP looks broken after the fast path (' + reason + '); freeing GPP and re-checking GPT.');
        takeOverGpp();
        startCmpRegistryRescueLoop();
    }

    function takeOverOrEscalate(reason) {
        if (watchdogState.fastPath) {
            escalateOutageDuringFastPath(reason);
            return;
        }
        takeOver(reason);
    }

    // -------------------------------------------------------------------------
    // Consent fast path (01102026): see the block above the watchdog.
    // -------------------------------------------------------------------------

    // Reads and normalises the template's country stamp. Returns the
    // two-letter upper-case code, or null when the stamp is missing or
    // unusable.
    function readFastPathCountry() {
        try {
            // First global in the list that carries a value wins; the name it
            // was found under is kept for debugging (fastPathStampGlobal).
            var rawValue;
            var globalIndex;
            for (globalIndex = 0; globalIndex < CONSENT_FAST_PATH_COUNTRY_GLOBALS.length; globalIndex++) {
                rawValue = window[CONSENT_FAST_PATH_COUNTRY_GLOBALS[globalIndex]];
                if (rawValue !== undefined && rawValue !== null) {
                    break;
                }
            }
            if (rawValue === undefined || rawValue === null) {
                watchdogState.fastPathStamp = null;
                return null;
            }
            watchdogState.fastPathStampGlobal = CONSENT_FAST_PATH_COUNTRY_GLOBALS[globalIndex];
            watchdogState.fastPathStamp = String(rawValue);
            if (typeof rawValue !== 'string') {
                return null;
            }
            var normalised = rawValue.replace(/^\s+|\s+$/g, '').toUpperCase();
            if (!/^[A-Z]{2}$/.test(normalised)) {
                return null;
            }
            return normalised;
        } catch (stampError) {
            return null;
        }
    }

    function isFastPathCountry(country) {
        var index;
        if (country === null) {
            return false;
        }
        for (index = 0; index < CONSENT_FAST_PATH_COUNTRIES.length; index++) {
            if (CONSENT_FAST_PATH_COUNTRIES[index] === country) {
                return true;
            }
        }
        return false;
    }

    // Asks the CMP for its status. The consentmanager stub and core both
    // answer "ping" synchronously; anything else returns null (= unknown,
    // no fast path).
    function pingTcfApiSynchronously(tcfApiFunction) {
        var pingData = null;
        try {
            tcfApiFunction('ping', 2, function (data, success) {
                if (success !== false && data && typeof data === 'object') {
                    pingData = data;
                }
            });
        } catch (pingError) {
            return null;
        }
        return pingData;
    }

    function skipFastPath(reason) {
        watchdogState.fastPathSkippedReason = reason;
        logWatchdog('consent fast path not applied: ' + reason);
    }

    function stopFastPathRescuePoll() {
        if (fastPathRescuePollTimer !== null) {
            clearInterval(fastPathRescuePollTimer);
            fastPathRescuePollTimer = null;
        }
    }

    // After a fast-path takeover: keeps the proxy in front of the CMP (an
    // outright redefinition of the property, not an assignment, bypasses the
    // accessor's setter) and keeps answering consumers found waiting in the
    // stub queue or the core registry, until the CMP's real answer is final
    // or the window closes.
    function startFastPathRescuePoll() {
        var waitedMilliseconds = 0;
        fastPathRescuePollTimer = setInterval(function () {
            try {
                waitedMilliseconds = waitedMilliseconds + CONSENT_FAST_PATH_RESCUE_POLL_MILLISECONDS;
                if (!syntheticAnswersActive() || waitedMilliseconds >= CONSENT_FAST_PATH_RESCUE_MAX_MILLISECONDS) {
                    stopFastPathRescuePoll();
                    return;
                }
                var descriptor = Object.getOwnPropertyDescriptor(window, '__tcfapi');
                if (descriptor && typeof descriptor.get !== 'function' && typeof descriptor.value === 'function' &&
                    descriptor.value !== proxiedTcfApiFunction) {
                    realTcfApi = descriptor.value;
                    installTcfApiAccessor(proxiedTcfApiFunction);
                    watchdogState.rewraps = watchdogState.rewraps + 1;
                    logWatchdog('window.__tcfapi was redefined; proxy re-installed in front of the new function.');
                }
                var answered = rescueStubQueueListeners() + rescueCmpHeldListeners();
                if (answered > 0) {
                    watchdogState.fastPathQueuedListenersAnswered = watchdogState.fastPathQueuedListenersAnswered + answered;
                    logWatchdog('fast path answered ' + answered + ' more consumer(s) found waiting inside the CMP.');
                }
            } catch (pollError) {
                stopFastPathRescuePoll();
            }
        }, CONSENT_FAST_PATH_RESCUE_POLL_MILLISECONDS);
    }

    // The fast-path takeover: the same synthetic "GDPR does not apply" answer
    // as an outage takeover, issued right now, TCF only, no recovery refresh.
    function takeOverFastPath(country, cmpStatusAtInstall) {
        watchdogState.takenOver = true;
        watchdogState.fastPath = true;
        watchdogState.fastPathCountry = country;
        watchdogState.fastPathCmpStatusAtInstall = cmpStatusAtInstall;
        watchdogState.fastPathAppliedAtMs = millisecondsSincePageStart();
        watchdogState.takeoverReason = 'consent fast path: template country stamp ' + country + ' (non-EEA), CMP ' + cmpStatusAtInstall;
        // For this page, consent stopped being a question right now.
        recordConsentFinal('fast_path_' + country);
        var listenerIndex;
        for (listenerIndex = 0; listenerIndex < proxiedListeners.length; listenerIndex++) {
            answerListenerSynthetically(proxiedListeners[listenerIndex]);
            watchdogState.fastPathProxiedListenersAnswered = watchdogState.fastPathProxiedListenersAnswered + 1;
        }
        var waitingAnswered = rescueStubQueueListeners() + rescueCmpHeldListeners();
        watchdogState.fastPathQueuedListenersAnswered = watchdogState.fastPathQueuedListenersAnswered + waitingAnswered;
        startFastPathRescuePoll();
        logWatchdog('consent fast path applied for ' + country + ' (CMP ' + cmpStatusAtInstall + ', timezone ' + watchdogState.timezone +
            ', ' + waitingAnswered + ' waiting consumer(s) answered) at ' + Math.round(watchdogState.fastPathAppliedAtMs) + ' ms; TCF answered synthetically until the CMP\'s own final answer.');
    }

    // Decides and, when every condition holds, applies the fast path. Runs
    // once, right after the proxy is installed (script execution time).
    function tryConsentFastPath() {
        try {
            if (!CONSENT_FAST_PATH_ENABLED) {
                skipFastPath('disabled');
                return;
            }
            var country = readFastPathCountry();
            if (country === null) {
                skipFastPath(watchdogState.fastPathStamp === null ? 'no_stamp' : 'unusable_stamp');
                return;
            }
            watchdogState.fastPathCountry = country;
            if (!isFastPathCountry(country)) {
                skipFastPath('country_not_listed:' + country);
                return;
            }
            // Same fail-safe as the outage takeover: a device that is clearly
            // in the EEA is never answered synthetically.
            if (deviceLooksEea()) {
                watchdogState.timezoneBlocked = true;
                skipFastPath('eea_device_timezone:' + watchdogState.timezone);
                return;
            }
            if (watchdogState.cmpFinal || watchdogState.cmpHealthy || watchdogState.takenOver) {
                skipFastPath('cmp_already_decided');
                return;
            }
            var pingData = pingTcfApiSynchronously(realTcfApi);
            if (pingData === null) {
                skipFastPath('ping_unanswered');
                return;
            }
            var cmpStatus = typeof pingData.cmpStatus === 'string' ? pingData.cmpStatus : 'unknown';
            if (cmpStatus === 'loaded' || cmpStatus === 'error' || cmpStatus === 'disabled') {
                // The CMP has decided (or given up) already; its answer is the
                // one every consumer should get, and gets.
                skipFastPath('cmp_already_' + cmpStatus);
                return;
            }
            takeOverFastPath(country, cmpStatus);
        } catch (fastPathError) {
            skipFastPath('error:' + fastPathError);
        }
    }

    // Watches a real CMP event. Final states per the TCF spec are "tcloaded"
    // (no UI needed) and "useractioncomplete" (user answered the banner).
    // "cmpuishown" is not final but proves the CMP is configured and working
    // for this visitor, so it counts as the CMP asserting itself.
    function observeRealEvent(tcData) {
        // A synthetic answer produced by this watchdog (delivered back to us
        // through the CMP registry rescue) must never count as the CMP
        // recovering -- only genuine CMP events may stand the watchdog down.
        if (tcData && tcData.syntheticWatchdogAnswer) {
            return;
        }
        if (!tcData) {
            return;
        }
        if (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete') {
            markCmpHealthy('real final event ' + tcData.eventStatus);
            markCmpFinal(tcData.eventStatus);
            return;
        }
        // A real answer saying GDPR does not apply is final for ad serving
        // even when the CMP has not flagged the event as final. From a loaded
        // CMP it is treated as the final answer outright (01102026).
        if (tcData.gdprApplies === false) {
            recordConsentFinal('gdpr_not_applicable');
            if (tcData.cmpStatus === 'loaded') {
                markCmpHealthy('real answer gdprApplies=false from a loaded CMP');
                markCmpFinal('gdpr_not_applicable');
                return;
            }
        }
        if (tcData.eventStatus === 'cmpuishown') {
            // The banner is up: the CMP governs this visitor from now on,
            // fast path or not.
            markCmpHealthy('real event cmpuishown');
            return;
        }
        if (tcData.cmpStatus === 'loaded' && !watchdogState.fastPath) {
            markCmpHealthy('real event ' + tcData.eventStatus + ' / cmpStatus ' + tcData.cmpStatus);
        }
        // Under the fast path a loaded-but-undecided CMP is progress, not an
        // answer: the synthetic answer stays in force until the real one.
    }



    // Consumers inside iframes -- and, on some pages, GPT itself -- talk to
    // the CMP through the TCF postMessage protocol aimed at the
    // __tcfapiLocator frame instead of calling window.__tcfapi directly.
    // Those requests never pass through the function proxy above, so after a
    // takeover the watchdog answers them here as well. Verified live on sd.rs
    // (03.09.2026): GPT bound itself to the postMessage path and stayed
    // blocked even after the function-path rescue -- __tcfapiCall messages
    // flowed with ZERO __tcfapiReturn replies from the broken CMP. While the
    // CMP is healthy (or before a takeover) this responder stays silent, and
    // it stands down permanently if the real CMP asserts itself.
    function installPostMessageResponder() {
        window.addEventListener('message', function (messageEvent) {
            if (!syntheticAnswersActive()) {
                return;
            }
            var payload = messageEvent && messageEvent.data;
            var usedJsonEncoding = false;
            if (typeof payload === 'string') {
                if (payload.indexOf('__tcfapiCall') === -1) {
                    return;
                }
                try {
                    payload = JSON.parse(payload);
                    usedJsonEncoding = true;
                } catch (parseError) {
                    return;
                }
            }
            if (!payload || !payload.__tcfapiCall || !messageEvent.source) {
                return;
            }
            var tcfCall = payload.__tcfapiCall;
            var returnValue;
            if (tcfCall.command === 'ping') {
                returnValue = {
                    gdprApplies: false,
                    cmpLoaded: true,
                    cmpStatus: 'loaded',
                    displayStatus: 'disabled',
                    apiVersion: '2.2',
                    cmpId: 31
                };
            } else {
                returnValue = buildSyntheticTcData();
            }
            var reply = { __tcfapiReturn: { returnValue: returnValue, success: true, callId: tcfCall.callId } };
            try {
                messageEvent.source.postMessage(usedJsonEncoding ? JSON.stringify(reply) : reply, '*');
            } catch (postError) {
                return;
            }
            // A consumer reached through this path may also have had its ad
            // requests dropped while blocked; make sure the one-time recovery
            // refresh check runs for this path too.
            if (tcfCall.command === 'addEventListener' || tcfCall.command === 'getTCData') {
                scheduleGptRedispatchIfSilent();
            }
        }, false);
    }

    // =========================================================================
    // GPP (GLOBAL PRIVACY PLATFORM) WATCHDOG
    // =========================================================================
    //
    // The same broken CMP that blocks TCF also implements a second, independent
    // consent signal API: GPP (Global Privacy Platform, used for US state
    // privacy laws and other non-EU frameworks). It fails identically:
    // window.__gpp answers every query with cmpStatus "loading" and
    // signalStatus "not ready" forever. Google Publisher Tag consults GPP in
    // addition to TCF before it will request ads, so even after the TCF
    // watchdog above frees GPT, a stuck GPP signal can still block ad serving
    // on its own. Confirmed live on sd.rs on 03.09.2026: TCF was fully
    // resolved (registry rescue answered every tcfv2 listener, prebid ran a
    // complete auction), yet zero ad requests ever fired until GPP was also
    // freed here.
    //
    // Mirrors the TCF watchdog's three surfaces -- the window.__gpp function,
    // the consentmanager registry (entries with type 'gpp'), and the
    // postMessage protocol via the __gppLocator frame -- and fires on the same
    // takeover as TCF. A healthy GPP resolves on its own and this code never
    // engages.

    var gppRealApi = null;
    var gppProxiedListeners = [];
    var gppNextSyntheticListenerId = 300000;
    var gppRescuedRegistryIds = {};

    // A resolved-and-nothing-applies GPP signal: no section of any privacy
    // framework currently applies, which is the correct declaration when the
    // audience is not covered by the regulations GPP encodes (this wrapper's
    // watchdog already declares the TCF/GDPR equivalent above for the same
    // non-EEA audience).
    function buildSyntheticGppPingData() {
        return {
            gppVersion: '1.1',
            cmpStatus: 'loaded',
            cmpDisplayStatus: 'hidden',
            signalStatus: 'ready',
            supportedAPIs: [],
            cmpId: 31,
            sectionList: [],
            applicableSections: [],
            gppString: '',
            parsedSections: {}
        };
    }

    // GPP's addEventListener callback receives an "event" object, not the ping
    // data directly. Different integrations read either event.data (spec says
    // a plain 'ready' string for the signalStatus event) or the ping-shaped
    // fields nested under event.pingData -- both are populated here, same
    // belt-and-braces approach as the TCF synthetic answer above.
    function buildSyntheticGppEvent(listenerId) {
        return {
            eventName: 'signalStatus',
            listenerId: listenerId,
            data: 'ready',
            pingData: buildSyntheticGppPingData()
        };
    }

    // GPP 1.1: a listener first hears listenerRegistered (data true), then the
    // signalStatus event. Both carry the ping-shaped fields as well.
    function answerGppListenerSynthetically(listenerEntry) {
        try {
            listenerEntry.callback({
                eventName: 'listenerRegistered',
                listenerId: listenerEntry.syntheticListenerId,
                data: true,
                pingData: buildSyntheticGppPingData()
            }, true);
            listenerEntry.callback(buildSyntheticGppEvent(listenerEntry.syntheticListenerId), true);
        } catch (listenerError) {
            logWatchdog('a GPP listener threw while receiving the synthetic answer: ' + listenerError);
        }
    }

    function takeOverGpp() {
        var listenerIndex;
        for (listenerIndex = 0; listenerIndex < gppProxiedListeners.length; listenerIndex++) {
            answerGppListenerSynthetically(gppProxiedListeners[listenerIndex]);
        }
        rescueGppRegistryListeners();
    }

    // Same shape as the TCF registry rescue, filtered to type 'gpp' entries;
    // deduped by registry id so a repeat retry pass never answers twice.
    function rescueGppRegistryListeners() {
        var rescuedCount = 0;
        try {
            var cmpVendorObject = window.cmpmngr;
            if (!cmpVendorObject || !cmpVendorObject.api || !cmpVendorObject.api.events || typeof cmpVendorObject.api.events.forEach !== 'function') {
                return 0;
            }
            cmpVendorObject.api.events.forEach(function (registryEntry) {
                if (!registryEntry || registryEntry.type !== 'gpp' || typeof registryEntry.listener !== 'function') {
                    return;
                }
                if (gppRescuedRegistryIds[registryEntry.id] === true) {
                    return;
                }
                gppRescuedRegistryIds[registryEntry.id] = true;
                try {
                    registryEntry.listener(buildSyntheticGppEvent(registryEntry.id), true);
                    rescuedCount = rescuedCount + 1;
                } catch (listenerError) {
                    logWatchdog('a CMP-held GPP listener threw while receiving the synthetic answer: ' + listenerError);
                }
            });
        } catch (rescueError) {
            logWatchdog('GPP registry rescue skipped: ' + rescueError);
        }
        return rescuedCount;
    }

    function installGppProxy() {
        if (typeof window.__gpp !== 'function') {
            return;
        }
        gppRealApi = window.__gpp;

        window.__gpp = function proxiedGpp(command, callback, parameter) {

            if (command === 'addEventListener' && typeof callback === 'function') {
                var listenerEntry = {
                    callback: callback,
                    syntheticListenerId: gppNextSyntheticListenerId
                };
                gppNextSyntheticListenerId = gppNextSyntheticListenerId + 1;
                gppProxiedListeners.push(listenerEntry);

                if (gppSyntheticAnswersActive()) {
                    answerGppListenerSynthetically(listenerEntry);
                }

                gppRealApi(command, function (event, success) {
                    if (gppSyntheticAnswersActive()) {
                        return;
                    }
                    callback(event, success);
                }, parameter);
                return;
            }

            if (command === 'removeEventListener') {
                var entryIndex;
                for (entryIndex = 0; entryIndex < gppProxiedListeners.length; entryIndex++) {
                    if (gppProxiedListeners[entryIndex].syntheticListenerId === parameter) {
                        gppProxiedListeners.splice(entryIndex, 1);
                        // GPP 1.1 shape: (data, success).
                        if (typeof callback === 'function') {
                            callback(true, true);
                        }
                        return;
                    }
                }
                gppRealApi(command, callback, parameter);
                return;
            }

            if (gppSyntheticAnswersActive()) {
                if (typeof callback === 'function') {
                    callback(buildSyntheticGppPingData(), true);
                    return;
                }
                return;
            }

            gppRealApi(command, callback, parameter);
        };
    }

    // Consumers reaching GPP through postMessage (__gppCall / __gppReturn via
    // the __gppLocator frame), same reasoning as the TCF postMessage responder
    // above: some consumers, including GPT itself on some page loads, never
    // call window.__gpp directly.
    function installGppPostMessageResponder() {
        window.addEventListener('message', function (messageEvent) {
            if (!gppSyntheticAnswersActive()) {
                return;
            }
            var payload = messageEvent && messageEvent.data;
            var usedJsonEncoding = false;
            if (typeof payload === 'string') {
                if (payload.indexOf('__gppCall') === -1) {
                    return;
                }
                try {
                    payload = JSON.parse(payload);
                    usedJsonEncoding = true;
                } catch (parseError) {
                    return;
                }
            }
            if (!payload || !payload.__gppCall || !messageEvent.source) {
                return;
            }
            var gppCallInfo = payload.__gppCall;
            var returnValue;
            if (gppCallInfo.command === 'addEventListener') {
                returnValue = buildSyntheticGppEvent(gppCallInfo.callId);
            } else if (gppCallInfo.command === 'removeEventListener') {
                // GPP 1.1: a boolean, never a ping object.
                returnValue = true;
            } else {
                returnValue = buildSyntheticGppPingData();
            }
            var reply = { __gppReturn: { returnValue: returnValue, success: true, callId: gppCallInfo.callId } };
            try {
                messageEvent.source.postMessage(usedJsonEncoding ? JSON.stringify(reply) : reply, '*');
            } catch (postError) {
                return;
            }
            scheduleGptRedispatchIfSilent();
        }, false);
    }


    // Puts the proxy in front of the real function as an ACCESSOR property on
    // window: the getter hands out the proxy, the setter captures the function
    // the CMP core assigns when it loads (consentmanager does a plain
    // `window.__tcfapi = ...`), so the proxy survives that assignment and keeps
    // forwarding to the current real function. Before 01102026 the proxy was a
    // plain value and the core's assignment silently took it out of the loop;
    // every consumer registering after that moment bypassed the watchdog.
    // Engines without accessor support on window fall back to the plain
    // assignment, and the fast-path rescue poll re-wraps if the CMP replaces
    // it then. Verified live on Pulsonline (30.09.2026) with the same vendor.
    function installTcfApiAccessor(proxyFunction) {
        try {
            // The stub keeps its postMessage handler on the function itself and
            // the CMP core looks it up there when it takes over; keep it
            // reachable on the proxy.
            if (realTcfApi && typeof realTcfApi.msgHandler === 'function' && typeof proxyFunction.msgHandler !== 'function') {
                proxyFunction.msgHandler = realTcfApi.msgHandler;
            }
        } catch (propertyError) {
            // ignore: a missing msgHandler only matters to the vendor's own code
        }
        try {
            Object.defineProperty(window, '__tcfapi', {
                configurable: true,
                enumerable: true,
                get: function () {
                    return proxyFunction;
                },
                set: function (newValue) {
                    if (typeof newValue === 'function' && newValue !== proxyFunction) {
                        realTcfApi = newValue;
                        watchdogState.cmpReplacements = watchdogState.cmpReplacements + 1;
                        logWatchdog('the CMP replaced window.__tcfapi; proxy kept in front of the new function.');
                    }
                }
            });
            watchdogState.accessorInstalled = true;
        } catch (defineError) {
            window.__tcfapi = proxyFunction;
            watchdogState.accessorInstalled = false;
        }
    }

    function installProxy() {
        realTcfApi = window.__tcfapi;
        watchdogState.wrapped = true;
        installPostMessageResponder();
        installGppProxy();
        installGppPostMessageResponder();

        proxiedTcfApiFunction = function proxiedTcfApi(command, version, callback, parameter) {

            // Called with no arguments the CMP stub hands back its command
            // queue (the CMP core collects it that way); pass that through.
            if (arguments.length === 0) {
                return typeof realTcfApi === 'function' ? realTcfApi() : undefined;
            }

            // --- addEventListener -------------------------------------------
            // Record the consumer so the watchdog can answer it on takeover,
            // and ALWAYS forward the registration to the real CMP (through the
            // filter) so that a healthy (or later-asserting) CMP drives the
            // consumer normally.
            if (command === 'addEventListener' && typeof callback === 'function') {
                var listenerEntry = findProxiedListener(callback);
                if (listenerEntry === null) {
                    listenerEntry = {
                        callback: callback,
                        syntheticListenerId: nextSyntheticListenerId,
                        realListenerId: null
                    };
                    nextSyntheticListenerId = nextSyntheticListenerId + 1;
                    proxiedListeners.push(listenerEntry);
                }

                try {
                    realTcfApi(command, version, buildTcfForwarder(listenerEntry), parameter);
                } catch (forwardError) {
                    logWatchdog('forwarding addEventListener to the CMP failed: ' + forwardError);
                }

                if (syntheticAnswersActive()) {
                    // Consumer registering while synthetic answers are in force
                    // (the fast path, or late after an outage takeover): answer
                    // immediately so it never hangs; the real CMP's final
                    // answer still reaches it through the forwarder above.
                    answerListenerSynthetically(listenerEntry);
                    if (watchdogState.fastPath) {
                        watchdogState.fastPathProxiedListenersAnswered = watchdogState.fastPathProxiedListenersAnswered + 1;
                    }
                }
                return undefined;
            }

            // --- removeEventListener ----------------------------------------
            // A synthetic id is confirmed locally, and the matching real
            // registration is removed from the CMP too once its real id is
            // known (the real CMP has never heard of the synthetic id).
            if (command === 'removeEventListener') {
                var entryIndex;
                for (entryIndex = 0; entryIndex < proxiedListeners.length; entryIndex++) {
                    if (proxiedListeners[entryIndex].syntheticListenerId === parameter) {
                        var removedEntry = proxiedListeners.splice(entryIndex, 1)[0];
                        if (removedEntry.realListenerId !== null && typeof realTcfApi === 'function') {
                            try {
                                realTcfApi('removeEventListener', version, function () {}, removedEntry.realListenerId);
                            } catch (removeError) {
                                // ignore: the consumer is gone either way
                            }
                        }
                        if (typeof callback === 'function') {
                            callback(true);
                        }
                        return undefined;
                    }
                }
                return realTcfApi(command, version, callback, parameter);
            }

            // --- getTCData / ping / everything else -------------------------
            // While synthetic answers are in force, answer one-shot queries
            // synthetically (the real CMP would only ever say "loading" or
            // "stub" then). Otherwise pure pass-through, with a peek at the
            // answer to spot progress or a final state.
            if (syntheticAnswersActive()) {
                if (command === 'ping' && typeof callback === 'function') {
                    callback({
                        gdprApplies: false,
                        cmpLoaded: true,
                        cmpStatus: 'loaded',
                        displayStatus: 'disabled',
                        apiVersion: '2.2',
                        cmpId: 31
                    }, true);
                    return undefined;
                }
                if (typeof callback === 'function') {
                    callback(buildSyntheticTcData(), true);
                    return undefined;
                }
                return undefined;
            }

            if (typeof callback === 'function') {
                return realTcfApi(command, version, function (tcData, success) {
                    observeRealEvent(tcData);
                    callback(tcData, success);
                }, parameter);
            }
            return realTcfApi.apply(null, arguments);
        };

        installTcfApiAccessor(proxiedTcfApiFunction);

        // The watchdog's own observer: register with the real CMP so progress
        // or a final state is noticed even if no other consumer ever registers.
        // Flagged so the stub-queue and registry passes never treat it as a
        // consumer to answer.
        var ownObserver = function watchdogOwnObserver(tcData, success) {
            if (success !== false) {
                observeRealEvent(tcData);
            }
        };
        ownObserver.watchdogTcfForwarder = true;
        try {
            realTcfApi('addEventListener', 2, ownObserver);
        } catch (observerError) {
            logWatchdog('could not register the watchdog observer with the CMP: ' + observerError);
        }

        proxyInstalledAtMilliseconds = nowMilliseconds();
        progressPollTimer = setInterval(evaluateCmpProgress, CMP_WATCHDOG_POLL_MILLISECONDS);
        logWatchdog('proxy installed; watching CMP progress (takeover ' + CMP_NO_DESIGN_CONFIRM_MILLISECONDS +
            'ms after an empty configuration answer, or after ' + CMP_WATCHDOG_MAX_WAIT_MILLISECONDS + 'ms without any progress).');

        // 01102026: the consent fast path, decided right now, at script
        // execution, before GPT or Prebid can ask the CMP anything else.
        tryConsentFastPath();
    }

    // The CMP stub normally exists before this file runs; if not, poll for a
    // while in case the template loads it late. No CMP at all means nothing
    // blocks ad serving, so the watchdog simply never engages.
    if (typeof window.__tcfapi === 'function') {
        installProxy();
    } else {
        var appearanceWaitedMilliseconds = 0;
        var appearancePollTimer = setInterval(function () {
            if (typeof window.__tcfapi === 'function') {
                clearInterval(appearancePollTimer);
                installProxy();
                return;
            }
            appearanceWaitedMilliseconds = appearanceWaitedMilliseconds + CMP_APPEARANCE_POLL_MILLISECONDS;
            if (appearanceWaitedMilliseconds >= CMP_APPEARANCE_MAX_WAIT_MILLISECONDS) {
                clearInterval(appearancePollTimer);
                logWatchdog('no __tcfapi appeared within ' + CMP_APPEARANCE_MAX_WAIT_MILLISECONDS + 'ms; nothing to guard.');
                // No CMP at all means consent never blocked anything; for the
                // telemetry the "final" moment is the wrapper's own start.
                recordConsentFinal('no_cmp');
            }
        }, CMP_APPEARANCE_POLL_MILLISECONDS);
    }
})();

// -----------------------------------------------------------------------------
// Debug mode (opt-in)
// -----------------------------------------------------------------------------
//
// Enable with:
//   - URL: ?addebug=1
// This mode MUST NOT change ad behavior; it only logs and exposes read-only state.
//
// Keep this small and robust: never throw, never block, never mutate ad logic.
//
var ADS_DEBUG_ENABLED = (function () {
    try {
        var searchParams = new URLSearchParams(window.location.search);
        return String(searchParams.get("addebug")) === "1";
    } catch (error) {
        return false;
    }
})();

function adsDebugLog() {
    if (!ADS_DEBUG_ENABLED) {
        return;
    }
    try {
        // eslint-disable-next-line no-console
        console.log.apply(console, arguments);
    } catch (error) {
        // Intentionally ignore logging failures.
    }
}

// ID5 for secure signals sharing in GAM
window.ID5EspConfig = { 
    partnerId: 1355 // ID5 partnerId
};


// =============================================================================
// FIRST-REQUEST TIMING TELEMETRY (15092026, passive)
// =============================================================================
//
// See the header of this file for the purpose. Everything here only reads
// clocks and writes page-level GPT key-values; nothing here delays, skips or
// reorders an ad request. Every function is wrapped in try/catch so a missing
// browser API can never break ad serving.

// Bucket edges in milliseconds, shared by both keys. The labels double as the
// exact value list that must exist under each key in GAM.
var FIRST_REQUEST_TIMING_BUCKETS = [
    { upTo: 500, label: 'lt_500' },
    { upTo: 1000, label: '500_999' },
    { upTo: 1500, label: '1000_1499' },
    { upTo: 2000, label: '1500_1999' },
    { upTo: 3000, label: '2000_2999' },
    { upTo: 5000, label: '3000_4999' }
];
var FIRST_REQUEST_TIMING_TOP_BUCKET = '5000_plus';
var FIRST_REQUEST_TIMING_UNKNOWN = 'unknown';
var CONSENT_WAIT_PENDING = 'pending';

// GPT key names. Both must be defined in GAM as predefined keys (custom
// dimension reporting) with the labels above plus 'unknown' (first request)
// and 'unknown' + 'pending' (consent wait).
var GPT_KEY_FIRST_REQUEST = 'aq_first_request';

// 01102026 arm B: aq_first_request values carry this prefix (b_lt_500 ...
// b_5000_plus, predefined on the key), so a plain CUSTOM_CRITERIA report
// tells the arms apart; arm A keeps the bare values. aq_consent_wait stays
// bare on both arms (pooled read).
var FIRST_REQUEST_ARM_PREFIX = 'b_';
var GPT_KEY_CONSENT_WAIT = 'aq_consent_wait';

// How often to re-check whether consent became final AFTER the first ad
// request went out with aq_consent_wait=pending, and for how long.
var CONSENT_WAIT_POLL_MILLISECONDS = 250;
var CONSENT_WAIT_POLL_MAX_MILLISECONDS = 60000;

// Raw timings for the debug snapshot. All values are milliseconds since the
// page's time origin (performance.now() clock), null until recorded.
var firstRequestTiming = {
    scriptStartMs: null,
    wrapperStartMs: null,
    wrapperStartReason: null,
    runWrapperMs: null,
    firstRequestBidsMs: null,
    firstRefreshCallMs: null,
    firstRefreshCallSlots: null,
    consentFinalMs: null,
    consentFinalReason: null,
    consentWaitAtFirstRequest: null,
    firstRequestBucket: null,
    consentWaitBucket: null,
    consentWaitBucketUpdatedAtMs: null,
    slotRequestedMs: {},
    slotResponseReceivedMs: {},
    slotRenderEndedMs: {}
};

// Milliseconds since the page's time origin; null when the clock is missing.
function timingNowMilliseconds() {
    try {
        if (window.performance && typeof window.performance.now === 'function') {
            return window.performance.now();
        }
    } catch (error) {
        return null;
    }
    return null;
}

// Maps a duration to its GAM bucket label.
function getFirstRequestTimingBucket(milliseconds) {
    if (milliseconds === null || milliseconds === undefined || isNaN(milliseconds)) {
        return FIRST_REQUEST_TIMING_UNKNOWN;
    }
    var bucketIndex;
    for (bucketIndex = 0; bucketIndex < FIRST_REQUEST_TIMING_BUCKETS.length; bucketIndex++) {
        if (milliseconds < FIRST_REQUEST_TIMING_BUCKETS[bucketIndex].upTo) {
            return FIRST_REQUEST_TIMING_BUCKETS[bucketIndex].label;
        }
    }
    return FIRST_REQUEST_TIMING_TOP_BUCKET;
}

// Reads the consent-final moment the watchdog recorded (see recordConsentFinal
// in the watchdog block). Returns null while consent is still pending.
function readConsentFinalFromWatchdog() {
    try {
        var watchdog = window.__cmpWatchdog;
        if (watchdog && typeof watchdog.consentFinalAtMs === 'number') {
            firstRequestTiming.consentFinalMs = watchdog.consentFinalAtMs;
            firstRequestTiming.consentFinalReason = watchdog.consentFinalReason || null;
            return watchdog.consentFinalAtMs;
        }
    } catch (error) {
        return null;
    }
    return null;
}

// Records a named milestone once (first call wins).
function recordFirstRequestMilestone(fieldName, extraFieldName, extraValue) {
    try {
        if (firstRequestTiming[fieldName] !== null) {
            return;
        }
        firstRequestTiming[fieldName] = timingNowMilliseconds();
        if (extraFieldName) {
            firstRequestTiming[extraFieldName] = extraValue;
        }
        adsDebugLog('[first-request] ' + fieldName, Math.round(firstRequestTiming[fieldName] || -1), extraValue || '');
    } catch (error) {
        // Telemetry must never throw into the wrapper.
    }
}

// Writes the consent-wait key-value at page level. Called at the first ad
// request and again if consent becomes final later (pending -> bucket).
function applyConsentWaitTargeting(bucketLabel) {
    try {
        googletag.pubads().setTargeting(GPT_KEY_CONSENT_WAIT, bucketLabel);
        firstRequestTiming.consentWaitBucket = bucketLabel;
        firstRequestTiming.consentWaitBucketUpdatedAtMs = timingNowMilliseconds();
        adsDebugLog('[first-request] ' + GPT_KEY_CONSENT_WAIT + '=' + bucketLabel);
    } catch (error) {
        // Ignore: page-level targeting is optional telemetry.
    }
}

// Polls the watchdog notes after a 'pending' first request so the page's later
// ad requests carry the real consent-wait bucket.
function startConsentWaitResolutionPoll() {
    var waitedMilliseconds = 0;
    var pollTimer = setInterval(function () {
        try {
            waitedMilliseconds = waitedMilliseconds + CONSENT_WAIT_POLL_MILLISECONDS;
            var consentFinalMs = readConsentFinalFromWatchdog();
            if (consentFinalMs !== null) {
                clearInterval(pollTimer);
                applyConsentWaitTargeting(getFirstRequestTimingBucket(consentFinalMs));
                return;
            }
            if (waitedMilliseconds >= CONSENT_WAIT_POLL_MAX_MILLISECONDS) {
                clearInterval(pollTimer);
            }
        } catch (error) {
            clearInterval(pollTimer);
        }
    }, CONSENT_WAIT_POLL_MILLISECONDS);
}

// Called immediately before EVERY initial googletag.pubads().refresh() call
// (Billboard first, then the rest of the ATF slots). Only the first call sets
// aq_first_request; later calls only upgrade aq_consent_wait from 'pending'.
function recordFirstRequestTelemetryBeforeRefresh(slotDescription) {
    try {
        var consentFinalMs = readConsentFinalFromWatchdog();

        if (firstRequestTiming.firstRefreshCallMs === null) {
            firstRequestTiming.firstRefreshCallMs = timingNowMilliseconds();
            firstRequestTiming.firstRefreshCallSlots = slotDescription;
            firstRequestTiming.firstRequestBucket = getFirstRequestTimingBucket(firstRequestTiming.firstRefreshCallMs);
            googletag.pubads().setTargeting(GPT_KEY_FIRST_REQUEST, FIRST_REQUEST_ARM_PREFIX + firstRequestTiming.firstRequestBucket);
            adsDebugLog('[first-request] ' + GPT_KEY_FIRST_REQUEST + '=' + firstRequestTiming.firstRequestBucket,
                'at', Math.round(firstRequestTiming.firstRefreshCallMs || -1), 'ms, slots', slotDescription);

            if (consentFinalMs !== null) {
                firstRequestTiming.consentWaitAtFirstRequest = getFirstRequestTimingBucket(consentFinalMs);
                applyConsentWaitTargeting(firstRequestTiming.consentWaitAtFirstRequest);
            } else {
                firstRequestTiming.consentWaitAtFirstRequest = CONSENT_WAIT_PENDING;
                applyConsentWaitTargeting(CONSENT_WAIT_PENDING);
                startConsentWaitResolutionPoll();
            }
            return;
        }

        // Not the first request: only upgrade a still-pending consent value.
        if (firstRequestTiming.consentWaitBucket === CONSENT_WAIT_PENDING && consentFinalMs !== null) {
            applyConsentWaitTargeting(getFirstRequestTimingBucket(consentFinalMs));
        }
    } catch (error) {
        // Telemetry must never throw into the wrapper.
    }
}

// GPT lifecycle listeners for the debug snapshot: first request / response /
// render time per slot. Registered through the GPT queue so pubads() exists.
function installFirstRequestGptListeners() {
    try {
        googletag.cmd.push(function () {
            function slotIdOf(event) {
                try {
                    return event.slot.getSlotElementId();
                } catch (error) {
                    return 'unknown';
                }
            }
            function recordSlotEvent(store, event) {
                try {
                    var slotId = slotIdOf(event);
                    if (store[slotId] === undefined) {
                        store[slotId] = timingNowMilliseconds();
                    }
                } catch (error) {
                    // Ignore.
                }
            }
            googletag.pubads().addEventListener('slotRequested', function (event) {
                recordSlotEvent(firstRequestTiming.slotRequestedMs, event);
            });
            googletag.pubads().addEventListener('slotResponseReceived', function (event) {
                recordSlotEvent(firstRequestTiming.slotResponseReceivedMs, event);
            });
            googletag.pubads().addEventListener('slotRenderEnded', function (event) {
                recordSlotEvent(firstRequestTiming.slotRenderEndedMs, event);
            });
        });
    } catch (error) {
        // Ignore: listeners are debug-only.
    }
}

// Debug snapshot for live verification: window.__zenaTimingSnapshot().
window.__zenaTimingSnapshot = function () {
    try {
        readConsentFinalFromWatchdog();
        var navigationTiming = null;
        try {
            var navigationEntries = window.performance.getEntriesByType('navigation');
            if (navigationEntries && navigationEntries.length > 0) {
                navigationTiming = {
                    domContentLoadedEventEndMs: navigationEntries[0].domContentLoadedEventEnd,
                    domInteractiveMs: navigationEntries[0].domInteractive,
                    responseEndMs: navigationEntries[0].responseEnd
                };
            }
        } catch (error) {
            navigationTiming = null;
        }
        var snapshot = JSON.parse(JSON.stringify(firstRequestTiming));
        snapshot.navigation = navigationTiming;
        // 01102026: the watchdog / fast-path state, copied so the snapshot is
        // self-contained for live checks.
        try {
            snapshot.watchdog = JSON.parse(JSON.stringify(window.__cmpWatchdog || null));
        } catch (watchdogCopyError) {
            snapshot.watchdog = null;
        }
        snapshot.nowMs = timingNowMilliseconds();
        return snapshot;
    } catch (error) {
        return firstRequestTiming;
    }
};

firstRequestTiming.scriptStartMs = timingNowMilliseconds();
installFirstRequestGptListeners();

// Amount of time (ms) that Prebid allows the bidders to respond to ad requests.
var PREBID_TIMEOUT = 1500;

// =============================================================================
// IN_TEXT_1 REAL-CONSENT HOLD (07102026, see the header)
// =============================================================================
// Everything here is top level on purpose: the dispatch code that uses it runs
// later, inside the GPT and Prebid command queues.

// Kill switch. false = In_Text_1 always stays in the first-screen batch (v1).
var IN_TEXT_1_REAL_CONSENT_HOLD_ENABLED = true;

// The Prebid ad unit code (= GPT div id) that is held.
var IN_TEXT_1_HOLD_AD_UNIT_CODE = 'In_Text_1';

// Longest wait for the real consent string, counted from the dispatch of the
// first-screen auctions. After that In_Text_1 is auctioned as on v1.
var IN_TEXT_1_REAL_CONSENT_MAX_WAIT_MILLISECONDS = 1500;

// When the CMP's real final answer is in but Prebid still holds no string
// after this long, the real answer has no string for this visitor: stop
// waiting (refreshing the Teads id would change nothing).
var IN_TEXT_1_REAL_ANSWER_WITHOUT_STRING_GRACE_MILLISECONDS = 300;

// Longest wait for the refreshed teadsId once the real string is in.
var IN_TEXT_1_TEADS_ID_MAX_WAIT_MILLISECONDS = 600;

// How often the two waits above look at Prebid's state.
var IN_TEXT_1_HOLD_POLL_MILLISECONDS = 50;

// Read-only state for live checks from the console.
// releaseReason: real_consent_string, real_answer_without_string, cap.
// teadsIdResult: present, absent_after_cap, refresh_error, skipped.
var inText1HoldState = {
    held: false,
    notHeldReason: null,
    heldAtMs: null,
    releasedAtMs: null,
    releaseReason: null,
    consentStringSizeAtRelease: null,
    teadsIdRefreshStartedAtMs: null,
    teadsIdResult: null,
    teadsIdReadyAtMs: null,
    auctionRequestedAtMs: null,
    gptRefreshAtMs: null
};
window.__zenaInText1Hold = inText1HoldState;

function inText1HoldNowMilliseconds() {
    try {
        if (window.performance && typeof window.performance.now === 'function') {
            return window.performance.now();
        }
    } catch (performanceError) {
        return Date.now();
    }
    return Date.now();
}

// True only while the watchdog's fast-path answer (empty tcString) is what
// TCF consumers hold: fast path applied and the real CMP not final yet.
function fastPathSyntheticAnswerInForce() {
    var watchdog = window.__cmpWatchdog;
    if (!watchdog) {
        return false;
    }
    if (watchdog.fastPath !== true) {
        return false;
    }
    if (watchdog.cmpFinal === true) {
        return false;
    }
    if (watchdog.cmpHealthy === true) {
        return false;
    }
    return true;
}

// Decides, at the dispatch of the first-screen auctions, whether In_Text_1 is
// taken out of the first-screen batch. Records why not when it is not.
function shouldHoldInText1(atfNonBillboardCodes) {
    if (IN_TEXT_1_REAL_CONSENT_HOLD_ENABLED !== true) {
        inText1HoldState.notHeldReason = 'disabled';
        return false;
    }
    if (atfNonBillboardCodes.indexOf(IN_TEXT_1_HOLD_AD_UNIT_CODE) === -1) {
        inText1HoldState.notHeldReason = 'no_in_text_1_on_page';
        return false;
    }
    if (!fastPathSyntheticAnswerInForce()) {
        inText1HoldState.notHeldReason = 'no_synthetic_answer';
        return false;
    }
    // Set here, before any other first-screen code runs, so the batch's
    // refresh list can never pick In_Text_1 up.
    inText1HoldState.held = true;
    return true;
}

// Length of the TCF string Prebid's consent module currently holds
// (0 = empty or not loaded yet).
function readPrebidConsentStringSize() {
    try {
        if (typeof pbjs.getConsentMetadata !== 'function') {
            return 0;
        }
        var metadata = pbjs.getConsentMetadata();
        if (metadata && metadata.gdpr && typeof metadata.gdpr.consentStringSize === 'number') {
            return metadata.gdpr.consentStringSize;
        }
    } catch (metadataError) {
        return 0;
    }
    return 0;
}

function readTeadsIdIsPresent() {
    try {
        var userIds = pbjs.getUserIds();
        if (userIds && userIds.teadsId) {
            return true;
        }
    } catch (userIdError) {
        return false;
    }
    return false;
}

// Step 1: wait for the real consent string (or the cap), then step 2.
function startInText1RealConsentHold() {
    inText1HoldState.heldAtMs = inText1HoldNowMilliseconds();
    adsDebugLog('[in-text-1-hold] In_Text_1 held for the real consent answer at',
        Math.round(inText1HoldState.heldAtMs), 'ms');

    var waitedMilliseconds = 0;
    var realAnswerWithoutStringMilliseconds = 0;
    var pollTimer = setInterval(function () {
        waitedMilliseconds = waitedMilliseconds + IN_TEXT_1_HOLD_POLL_MILLISECONDS;

        var consentStringSize = readPrebidConsentStringSize();
        var releaseReason = null;

        if (consentStringSize > 0) {
            releaseReason = 'real_consent_string';
        } else {
            if (!fastPathSyntheticAnswerInForce()) {
                realAnswerWithoutStringMilliseconds = realAnswerWithoutStringMilliseconds + IN_TEXT_1_HOLD_POLL_MILLISECONDS;
                if (realAnswerWithoutStringMilliseconds >= IN_TEXT_1_REAL_ANSWER_WITHOUT_STRING_GRACE_MILLISECONDS) {
                    releaseReason = 'real_answer_without_string';
                }
            }
            if (releaseReason === null && waitedMilliseconds >= IN_TEXT_1_REAL_CONSENT_MAX_WAIT_MILLISECONDS) {
                releaseReason = 'cap';
            }
        }

        if (releaseReason === null) {
            return;
        }

        clearInterval(pollTimer);
        inText1HoldState.releasedAtMs = inText1HoldNowMilliseconds();
        inText1HoldState.releaseReason = releaseReason;
        inText1HoldState.consentStringSizeAtRelease = consentStringSize;
        adsDebugLog('[in-text-1-hold] released (' + releaseReason + ', consent string length ' + consentStringSize + ') at',
            Math.round(inText1HoldState.releasedAtMs), 'ms');

        if (releaseReason === 'real_consent_string') {
            refreshTeadsIdThenAuctionInText1();
        } else {
            inText1HoldState.teadsIdResult = 'skipped';
            requestInText1Auction();
        }
    }, IN_TEXT_1_HOLD_POLL_MILLISECONDS);
}

// Step 2: refetch only the Teads id with the real string, wait for it (or
// the cap), then auction In_Text_1.
function refreshTeadsIdThenAuctionInText1() {
    inText1HoldState.teadsIdRefreshStartedAtMs = inText1HoldNowMilliseconds();
    try {
        pbjs.refreshUserIds({ submoduleNames: ['teadsId'] });
    } catch (refreshError) {
        inText1HoldState.teadsIdResult = 'refresh_error';
        requestInText1Auction();
        return;
    }

    var waitedMilliseconds = 0;
    var pollTimer = setInterval(function () {
        waitedMilliseconds = waitedMilliseconds + IN_TEXT_1_HOLD_POLL_MILLISECONDS;

        if (readTeadsIdIsPresent()) {
            clearInterval(pollTimer);
            inText1HoldState.teadsIdResult = 'present';
            inText1HoldState.teadsIdReadyAtMs = inText1HoldNowMilliseconds();
            requestInText1Auction();
            return;
        }

        if (waitedMilliseconds >= IN_TEXT_1_TEADS_ID_MAX_WAIT_MILLISECONDS) {
            clearInterval(pollTimer);
            inText1HoldState.teadsIdResult = 'absent_after_cap';
            requestInText1Auction();
        }
    }, IN_TEXT_1_HOLD_POLL_MILLISECONDS);
}

// Step 3: In_Text_1's own Prebid auction, then its first GPT request. Same
// timeout as the first-screen batch it was taken out of.
function requestInText1Auction() {
    inText1HoldState.auctionRequestedAtMs = inText1HoldNowMilliseconds();
    var adServerCalled = false;

    function sendInText1ToAdServer() {
        if (adServerCalled) {
            return;
        }
        adServerCalled = true;
        googletag.cmd.push(function () {
            pbjs.que.push(function () {
                pbjs.setTargetingForGPTAsync([IN_TEXT_1_HOLD_AD_UNIT_CODE]);
                // Telemetry (15092026): only upgrades a pending consent-wait
                // value here, the first request of the page has long gone.
                recordFirstRequestTelemetryBeforeRefresh(IN_TEXT_1_HOLD_AD_UNIT_CODE);
                inText1HoldState.gptRefreshAtMs = inText1HoldNowMilliseconds();
                googletag.pubads().refresh([In_Text_1]);
            });
        });
    }

    pbjs.que.push(function () {
        pbjs.requestBids({
            adUnitCodes: [IN_TEXT_1_HOLD_AD_UNIT_CODE],
            bidsBackHandler: sendInText1ToAdServer,
            timeout: getPrebidTimeoutForAdUnit(IN_TEXT_1_HOLD_AD_UNIT_CODE)
        });
    });
}

// Per-adunit Prebid timeout overrides (ms)
var PREBID_TIMEOUT_BY_ADUNIT = {};

function getPrebidTimeoutForAdUnit(adUnitCode) {
    if (adUnitCode && PREBID_TIMEOUT_BY_ADUNIT && PREBID_TIMEOUT_BY_ADUNIT[adUnitCode]) {
        return PREBID_TIMEOUT_BY_ADUNIT[adUnitCode];
    }
    return PREBID_TIMEOUT;
}

// Refresh cadence for the currently rendered advertiser.
// Listed Direct advertisers use the longer interval in every slot (same
// behavior as Blic.rs, changed 28 Jul 2026 — previously Billboard only).
// Every other eligible impression uses the 20-second default interval.
var DEFAULT_REFRESH_INTERVAL_SECONDS = 20;
var DIRECT_ADVERTISER_REFRESH_INTERVAL_SECONDS = 30;
var GAM_DIRECT_ADVERTISER_IDS = [
    5081634183,
    5081526668
];

// Legacy/default interval used by older helper paths and debug output. Runtime
// scheduling uses getRefreshIntervalSeconds(divId).
var SECONDS_TO_WAIT_AFTER_VIEWABILITY = DEFAULT_REFRESH_INTERVAL_SECONDS;


// Cumulative viewability timer (pauses when not viewable).
// When enabled, the selected interval counts cumulatively, but requires the last continuous
// visible stretch to be at least 5s and currently >= VISIBILITY_PERCENT_FOR_REFRESH.
var USE_CUMULATIVE_VIEWABILITY_TIMER = true;
var MIN_CONTINUOUS_VIEWABILITY_SEGMENT_MS = 5000;
// Advertisers for which refresh shouldn't apply. Just add the company IDs e.g [3219368852, 3130234283].
var GAM_NOREFRESH_ADVERTISER_IDS = [];

// Campaigns for which refresh shouldn't apply. Just add the order IDs e.g [3219368852, 3130234283].
var GAM_NOREFRESH_ORDER_IDS = [];

// Ad units (div ids) for which refresh shouldn't apply. Just add the div IDs e.g ['Branding_Left', 'Branding_Right'].
var GAM_NOREFRESH_ADUNITS = ['Branding_Left', 'Branding_Right'];

// How far should the ad be for the lazy loading to activate.
var DISTANCE_IN_PIXELS_FOR_LAZY_LOADING = "500px";

// How much (in percent) should the ad slot be viewable. 
var VISIBILITY_PERCENT_FOR_REFRESH = 0.7;

// Variables for all defined slots. 
var Adhesion;
var Billboard;
var Billboard_2;
var Billboard_3;
var Billboard_4;
var Billboard_5;
var Branding_Left;
var Branding_Right;
var P1;
var P2;
var P3;
var P4;
var P5;
var P6;
var In_Text_1;
var In_Text_2;
var In_Text_3;
var In_Text_4;
var In_Text_5;
var In_Text_6;
var In_Text_7;
var In_Text_8;
var In_Text_9;
var In_Text_10;

// Top level ad unit path. 
var adUnitPath = "/161634325/Zena.rs/";

var adWindowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; //check user's screen width

// Ogury uses one shared mobile adUnitId across all Zena.rs positions.
var OGURY_MOBILE_ALL_ADUNIT_ID = "wm-hb-stdb-zena-ringi-87be1jqd3ecilt";

function getOguryAdUnitIdForDevice(desktopAdUnitId) {
    // Matches the wrapper size mapping: [0, 0] mobile, [469, 0] tablet.
    if (adWindowWidth < 469) {
        return OGURY_MOBILE_ALL_ADUNIT_ID;
    }
    return desktopAdUnitId;
}

// ATF and BTF array variables. 
var adUnitsATF = [];
var adUnitsBTF = [];

// 22092026: Prebid demand on the web interstitial (see the header block).
var INTERSTITIAL_PREBID_ENABLED = true; // kill switch: false = no interstitial slot, no auction (previous build)
var INTERSTITIAL_GAM_AD_UNIT_LEAF = 'Interstitial'; // GAM ad unit under adUnitPath: /161634325/Zena.rs/Interstitial
var INTERSTITIAL_ADFORM_MID = '2294693'; // Adform placement for the interstitial, configured as 300x250 on Adform's side
var Interstitial; // GPT out-of-page web interstitial slot; stays undefined when GPT refuses it or already holds one
var interstitialPrebidAdUnitCode = null; // Prebid ad unit code = the slot's auto-generated element id
var adUnitsInterstitial = []; // Prebid ad units for the interstitial (0 or 1 entries), consumed like adUnitsATF

// Live-check object (read-only diagnostics, drives no behaviour).
window.__zenaInterstitialState = {
    enabled: INTERSTITIAL_PREBID_ENABLED,
    defined: false,
    slotElementId: null,
    reason: 'not_started',
    auctionRequested: false,
    auctionAnswered: false,
    bidCount: null,
    topBidCpm: null,
    gptRequested: false
};

function runWrapper() {

    //console.log('Ad Wrapper: Script execution.');

    // Telemetry (15092026): GPT is loaded and slot definition begins.
    recordFirstRequestMilestone('runWrapperMs');

    var adContainers = document.querySelectorAll('.wrapperAd'); // Find all divs which have wrapperAd class.

    googletag.cmd.push(function() { // Push the defined ad units to the GPT array.

        // Sticky GPT size mapping. 
        var sticky_mapping = googletag.sizeMapping()
        .addSize([1600, 0], [[728, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200], [1, 1]]) //desktop for bigger screens
        .addSize([1024, 0], [[728, 90], [750, 100], [1, 1]]) //desktop for smaller screens
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50], [1, 1]]) //tablet
        .addSize([0, 0], [[300, 50], [320, 50], [300, 100], [320, 100], [1, 1]]) //mobile
        .build();

        // Billboard GPT size mapping.
        var billboard_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[728, 90], [970, 66], [950, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200], [980, 120], [930, 180], [970, 250], [980, 240], [980, 250], [990, 250], [1060, 250]]) //desktop
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50]]) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100], [360, 50], [360, 100]]) //mobile
        .build();   
        
        // Billboard_# GPT size mapping.
        var billboard_infeed_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[728, 90], [970, 66], [950, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200], [580, 280], [980, 120], [930, 180], [970, 250], [980, 240], [980, 250], [990, 250], [1060, 250]]) //desktop
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50]]) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100], [360, 50], [360, 100]]) //mobile
        .build();    

        // P GPT size mapping.
        var p_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]]) //desktop
        .addSize([469, 0], [[200, 200], [250, 250], [300, 250]]) //tablet
        .addSize([0, 0], [[200, 200], [250, 250], [300, 250], [336, 280]]) //mobile
        .build();

        // InText GPT size mapping.
        var inText_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[728, 90], [750, 100], [750, 200], [750, 250], [580, 280], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //desktop
        .addSize([469, 0], [[300, 50], [320, 50], [468, 60], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //mobile
        .build();

        // Branding (Left/Right) GPT size mapping (desktop-only).
        //
        // These are premium skin positions:
        // - Desktop only (no slot defined for tablet/mobile).
        // - Never lazy-loaded.
        // - Never refreshed (excluded via GAM_NOREFRESH_ADUNITS).
        //
        // Size provided by GAM:
        //   - 470x1080
        //
        var branding_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[470, 1080]]) //desktop only
        .addSize([0, 0], []) //no branding on tablet/mobile
        .build();


        adContainers.forEach(function(el) { // Runs through all of the wrapperAd divs.

            // **************** Sticky GPT and Prebid definition. *******************

            if (el.id === 'Adhesion') { // Check if Adhesion div is present in body. 

                // Sticky ad unit definition
                Adhesion = googletag.defineSlot(adUnitPath + 'Sticky', [[728, 90], [970, 90], [320, 50]], 'Adhesion')
                                    .defineSizeMapping(sticky_mapping)
                                    .setTargeting('position', 'Adhesion')
                                    .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                    .addService(googletag.pubads());
                
                // Push the defined Adhesion Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Adhesion',
                        mediaTypes: {banner: {
                        // 21092026: desktop Prebid sizes aligned with the GPT sticky_mapping. GPT already requested
                        // 980x90 + 1000x100 (>= 1600 px) and 750x100 (1024-1599 px) for this slot, so AdX and direct
                        // could serve them while Prebid never asked. Same slot height as today -> no layout shift.
                        sizeConfig: [
                            { minViewPort: [1600, 0], sizes: [[728, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200]] }, //desktop for bigger screens (21092026: += 980x90, 1000x100)
                            { minViewPort: [1024, 0], sizes: [[728, 90], [750, 100]] }, //desktop for smaller screens (21092026: += 750x100)
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984534', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275345', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-foot-zena-ringi-t24yasls3z0v2g") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_1_970x90" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991973" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476543" } },
                            { bidder: "richaudience", params: { pid: "oyEVxRv41q", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912382 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120620" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            // **************** Billboard GPT and Prebid definition. *******************

            else if (el.id === 'Billboard') { // Check if Billboard div is present in body. 

                // Billboard ad unit definition
                Billboard = googletag.defineSlot(adUnitPath + 'Billboard', [[970, 250]], 'Billboard')
                                     .defineSizeMapping(billboard_mapping)
                                     .setTargeting('position', 'Billboard')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined Billboard Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Billboard',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250], [980, 90], [1000, 100], [980, 250]] }, //desktop (21092026: += 980x90, 1000x100, 980x250 -- GPT billboard mappings already serve them, same heights as today)
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984534', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275346', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-ey0lfyk9ppey8g") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_2_970x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991974" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476544" } },
                            { bidder: "richaudience", params: { pid: "vg1gFU2yNO", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912384 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120621" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },]
                    }
                );

            }

            // **************** Billboard_2 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_2') { // Check if Billboard_2 div is present in body. 

                // Billboard_2 ad unit definition
                Billboard_2 = googletag.defineSlot(adUnitPath + 'Billboard_2', [[970, 250]], 'Billboard_2')
                                     .defineSizeMapping(billboard_infeed_mapping)
                                     .setTargeting('position', 'Billboard_2')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined Billboard_2 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_2',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250], [980, 90], [1000, 100], [980, 250]] }, //desktop (21092026: += 980x90, 1000x100, 980x250 -- GPT billboard mappings already serve them, same heights as today)
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984535', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275348', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-tg-thmb-zena-ringi-k61afyverj6f2v") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_3_970x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033459" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994830" } },
                            { bidder: "richaudience", params: { pid: "kVcQf5Nxcs", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035360 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125758" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            // **************** Billboard_3 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_3') { // Check if Billboard_3 div is present in body. 

                // Billboard_3 ad unit definition
                Billboard_3 = googletag.defineSlot(adUnitPath + 'Billboard_3', [[970, 250]], 'Billboard_3')
                                     .defineSizeMapping(billboard_infeed_mapping)
                                     .setTargeting('position', 'Billboard_3')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined Billboard_3 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_3',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250], [980, 90], [1000, 100], [980, 250]] }, //desktop (21092026: += 980x90, 1000x100, 980x250 -- GPT billboard mappings already serve them, same heights as today)
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984535', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275347', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-tg-thmb-zena-ringi-k61afyverj6f2v") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_4_970x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033460" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994831" } },
                            { bidder: "richaudience", params: { pid: "U7LyzSqxUn", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035362 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125759" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            // **************** Billboard_4 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_4') { // Check if Billboard_4 div is present in body. 

                // Billboard_4 ad unit definition
                Billboard_4 = googletag.defineSlot(adUnitPath + 'Billboard_4', [[970, 250]], 'Billboard_4')
                                     .defineSizeMapping(billboard_infeed_mapping)
                                     .setTargeting('position', 'Billboard_4')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined Billboard_4 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_4',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250], [980, 90], [1000, 100], [980, 250]] }, //desktop (21092026: += 980x90, 1000x100, 980x250 -- GPT billboard mappings already serve them, same heights as today)
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984535', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275349', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-tg-thmb-zena-ringi-k61afyverj6f2v") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_5_970x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033461" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994832" } },
                            { bidder: "richaudience", params: { pid: "qYQW0HpZCT", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035364 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125760" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            // **************** Billboard_5 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_5') { // Check if Billboard_5 div is present in body. 

                // Billboard_5 ad unit definition
                Billboard_5 = googletag.defineSlot(adUnitPath + 'Billboard_5', [[970, 250]], 'Billboard_5')
                                     .defineSizeMapping(billboard_infeed_mapping)
                                     .setTargeting('position', 'Billboard_5')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined Billboard_5 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_5',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250], [980, 90], [1000, 100], [980, 250]] }, //desktop (21092026: += 980x90, 1000x100, 980x250 -- GPT billboard mappings already serve them, same heights as today)
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984535', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275350', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-tg-thmb-zena-ringi-k61afyverj6f2v") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_6_970x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033462" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994833" } },
                            { bidder: "richaudience", params: { pid: "0o4YNDox46", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035366 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125761" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            
            // **************** Branding_Left GPT and Prebid definition. *******************

            else if (el.id === 'Branding_Left') { // Check if Branding_Left div is present in body.

                // Desktop-only guard: do not define the slot on smaller viewports.
                if (adWindowWidth < 1024) {
                    return;
                }

                // Branding_Left ad unit definition
                Branding_Left = googletag.defineSlot(adUnitPath + 'Branding_Left', [[470, 1080]], 'Branding_Left')
                                        .defineSizeMapping(branding_mapping)
                                        .setTargeting('position', 'Branding_Left')
                                        .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                        .addService(googletag.pubads());

                // Push the defined Branding_Left Prebid placement to the ATF array.
                //
                // IMPORTANT:
                // Bidder parameters below are mirrored from the site's standard desktop stack.
                // Replace placement / site / unit / zone / format IDs with branding-specific values
                // if your demand sources require separate inventory mappings for this position.
                //
            }

            // **************** Branding_Right GPT and Prebid definition. *******************

            else if (el.id === 'Branding_Right') { // Check if Branding_Right div is present in body.

                // Desktop-only guard: do not define the slot on smaller viewports.
                if (adWindowWidth < 1024) {
                    return;
                }

                // Branding_Right ad unit definition
                Branding_Right = googletag.defineSlot(adUnitPath + 'Branding_Right', [[470, 1080]], 'Branding_Right')
                                         .defineSizeMapping(branding_mapping)
                                         .setTargeting('position', 'Branding_Right')
                                         .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                         .addService(googletag.pubads());

                // Push the defined Branding_Right Prebid placement to the ATF array.
                // See Branding_Left notes regarding bidder IDs.
            }

// **************** P1 GPT and Prebid definition. *******************

            else if (el.id === 'P1') { // Check if P1 div is present in body. 

                // P1 ad unit definition
                P1 = googletag.defineSlot(adUnitPath + 'P1', [[300, 250]], 'P1')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P1')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                              .addService(googletag.pubads());
                
                // Push the defined P1 Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'P1',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984536', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275351', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-jgiwyeft5krd1o") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_7_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991975" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476545" } },
                            { bidder: "richaudience", params: { pid: "lBGbZPWXCn", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912386 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120624" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            // **************** P2 GPT and Prebid definition. *******************

            else if (el.id === 'P2') { // Check if P2 div is present in body. 

                // P2 ad unit definition
                P2 = googletag.defineSlot(adUnitPath + 'P2', [[300, 250]], 'P2')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P2')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                              .addService(googletag.pubads());
                
                // Push the defined P2 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P2',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984536', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275358', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-jgiwyeft5krd1o") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_8_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991976" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476546" } },
                            { bidder: "richaudience", params: { pid: "OJdO4EWcAK", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912388 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120625" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            // **************** P3 GPT and Prebid definition. *******************

            else if (el.id === 'P3') { // Check if P3 div is present in body. 

                // P3 ad unit definition
                P3 = googletag.defineSlot(adUnitPath + 'P3', [[300, 250]], 'P3')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P3')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                              .addService(googletag.pubads());
                
                // Push the defined P3 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P3',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984536', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275357', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-jgiwyeft5krd1o") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_9_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991977" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476547" } },
                            { bidder: "richaudience", params: { pid: "MctgD0vfro", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912390 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120626" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }   

            
            // **************** P4 GPT and Prebid definition. *******************

            else if (el.id === 'P4') { // Check if P4 div is present in body. 

                // P4 ad unit definition
                P4 = googletag.defineSlot(adUnitPath + 'P4', [[300, 250]], 'P4')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P4')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                              .addService(googletag.pubads());
                
                // Push the defined P4 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P4',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984536', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275356', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-jgiwyeft5krd1o") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_10_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033463" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994841" } },
                            { bidder: "richaudience", params: { pid: "p0Ntp09R6q", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035368 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "123584" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }   

            // **************** P5 GPT and Prebid definition. *******************

            else if (el.id === 'P5') { // Check if P5 div is present in body. 

                // P5 ad unit definition
                P5 = googletag.defineSlot(adUnitPath + 'P5', [[300, 250]], 'P5')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P5')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                              .addService(googletag.pubads());
                
                // Push the defined P5 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P5',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984536', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275355', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-jgiwyeft5krd1o") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_11_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033464" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994842" } },
                            { bidder: "richaudience", params: { pid: "bUJXke5UHk", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035370 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125177" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }   

            // **************** P6 GPT and Prebid definition. *******************

            else if (el.id === 'P6') { // Check if P6 div is present in body. 

                // P6 ad unit definition
                P6 = googletag.defineSlot(adUnitPath + 'P6', [[300, 250]], 'P6')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P6')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                              .addService(googletag.pubads());
                
                // Push the defined P6 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P6',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984536', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275354', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-jgiwyeft5krd1o") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_12_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033465" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994843" } },
                            { bidder: "richaudience", params: { pid: "LnZhqdRKkF", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035372 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125178" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }   

            // **************** In_Text_1 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_1') { // Check if In_Text_1 div is present in body. 

                // In_Text_1 ad unit definition
                In_Text_1 = googletag.defineSlot(adUnitPath + 'In_Text_1', [[300, 250]], 'In_Text_1')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_1')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_1 Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'In_Text_1',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275353', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_13_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991978" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476548" } },
                            { bidder: "richaudience", params: { pid: "azi8RABPMM", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912392 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120627" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }   

            // **************** In_Text_2 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_2') { // Check if In_Text_2 div is present in body. 

                // In_Text_2 ad unit definition
                In_Text_2 = googletag.defineSlot(adUnitPath + 'In_Text_2', [[300, 250]], 'In_Text_2')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_2')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined InText_2 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_2',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275352', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_14_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991979" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476549" } },
                            { bidder: "richaudience", params: { pid: "bQd1RgORcx", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912394 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120628" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }   

            // **************** In_Text_3 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_3') { // Check if In_Text_3 div is present in body. 

                // In_Text_3 ad unit definition
                In_Text_3 = googletag.defineSlot(adUnitPath + 'In_Text_3', [[300, 250]], 'In_Text_3')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_3')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_3 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_3',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275365', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_15_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991980" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476550" } },
                            { bidder: "richaudience", params: { pid: "H0Vc4jkbuk", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912396 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120629" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_4 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_4') { // Check if In_Text_4 div is present in body. 

                // In_Text_4 ad unit definition
                In_Text_4 = googletag.defineSlot(adUnitPath + 'In_Text_4', [[300, 250]], 'In_Text_4')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_4')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_4 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_4',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275364', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_16_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033466" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994848" } },
                            { bidder: "richaudience", params: { pid: "VuW0a2MBDN", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035374 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "124582" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_5 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_5') { // Check if In_Text_5 div is present in body. 

                // In_Text_5 ad unit definition
                In_Text_5 = googletag.defineSlot(adUnitPath + 'In_Text_5', [[300, 250]], 'In_Text_5')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_5')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_5 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_5',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275363', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_17_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033467" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994849" } },
                            { bidder: "richaudience", params: { pid: "Iwud03aPvs", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035376 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "124583" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_6 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_6') { // Check if In_Text_6 div is present in body. 

                // In_Text_6 ad unit definition
                In_Text_6 = googletag.defineSlot(adUnitPath + 'In_Text_6', [[300, 250]], 'In_Text_6')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_6')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_6 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_6',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275362', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_18_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033468" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559748196" } },
                            { bidder: "richaudience", params: { pid: "7xuQMWsEpc", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035378 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125172" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_7 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_7') { // Check if In_Text_7 div is present in body. 

                // In_Text_7 ad unit definition
                In_Text_7 = googletag.defineSlot(adUnitPath + 'In_Text_7', [[300, 250]], 'In_Text_7')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_7')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_7 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_7',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275361', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_19_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033469" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559748197" } },
                            { bidder: "richaudience", params: { pid: "lzCojWESyN", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035380 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125173" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_8 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_8') { // Check if In_Text_8 div is present in body. 

                // In_Text_8 ad unit definition
                In_Text_8 = googletag.defineSlot(adUnitPath + 'In_Text_8', [[300, 250]], 'In_Text_8')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_8')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_8 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_8',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275360', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_20_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033470" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559748198" } },
                            { bidder: "richaudience", params: { pid: "Nqgrg220pk", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035382 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125174" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_9 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_9') { // Check if In_Text_9 div is present in body. 

                // In_Text_9 ad unit definition
                In_Text_9 = googletag.defineSlot(adUnitPath + 'In_Text_9', [[300, 250]], 'In_Text_9')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_9')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_9 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_9',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275359', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_21_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033471" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559748199" } },
                            { bidder: "richaudience", params: { pid: "Pzep8tfX9w", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035384 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125175" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_10 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_10') { // Check if In_Text_10 div is present in body. 

                // In_Text_10 ad unit definition
                In_Text_10 = googletag.defineSlot(adUnitPath + 'In_Text_10', [[300, 250]], 'In_Text_10')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_10')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_10 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_10',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275366', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_22_300x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033472" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559748200" } },
                            { bidder: "richaudience", params: { pid: "lIU3RBXxTT", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035386 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125176" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

        }); // End of wrapperAd divs check. 

        //Create sticky ad once the ad is ready to render
        googletag.pubads().addEventListener('slotRenderEnded', function(event) {

            // Passive render-result telemetry for future adaptive-refresh analysis.
            try {
                var renderedDivId = event.slot && event.slot.getSlotElementId && event.slot.getSlotElementId();
                if (renderedDivId) {
                    var renderedState = getOrCreateRefreshState(renderedDivId);
                    var renderTimestamp = Date.now();
                    var recentPrebidWin = auctionQualityRecentPrebidWinsByAdUnit[renderedDivId] || null;
                    var renderedSource = Boolean(event.isEmpty)
                        ? "unfilled"
                        : (recentPrebidWin && (renderTimestamp - recentPrebidWin.timestamp) <= 10000 ? "prebid" : "gam");

                    renderedState.lastRenderResult = {
                        timestamp: renderTimestamp,
                        isEmpty: Boolean(event.isEmpty),
                        source: renderedSource,
                        prebidWin: renderedSource === "prebid" ? recentPrebidWin : null,
                        advertiserId: event.advertiserId || null,
                        campaignId: event.campaignId || null,
                        lineItemId: event.lineItemId || null,
                        creativeId: event.creativeId || null,
                        sourceAgnosticCreativeId: event.sourceAgnosticCreativeId || null,
                        sourceAgnosticLineItemId: event.sourceAgnosticLineItemId || null,
                        yieldGroupIds: event.yieldGroupIds || null
                    };

                    try {
                        // Start a fresh cadence window for the newly rendered creative.
                        // Any slot rendering a listed Direct advertiser switches to 30
                        // seconds; every other refreshable slot uses 20 seconds.
                        renderedState.cumulativeViewableMs = 0;
                        renderedState.lastAboveThresholdTimestamp = renderedState.isAboveVisibilityThreshold
                            ? renderTimestamp
                            : null;

                        if (
                            renderedState.isAboveVisibilityThreshold &&
                            document.visibilityState === "visible" &&
                            !GAM_NOREFRESH_ADUNITS.includes(renderedDivId)
                        ) {
                            adsDebugLog(
                                "[ads-refresh]",
                                renderedDivId,
                                "render cadence selected",
                                {
                                    advertiserId: renderedState.lastRenderResult.advertiserId,
                                    intervalSeconds: getRefreshIntervalSeconds(renderedDivId)
                                }
                            );
                            scheduleRefreshWindowFromNow(renderedDivId);
                        }
                    } catch (cadenceError) {
                        adsDebugLog(
                            "[ads-refresh]",
                            renderedDivId,
                            "render cadence update failed",
                            String(cadenceError)
                        );
                    }
                }
            } catch (telemetryError) {
                adsDebugLog("[auction-quality] render_capture_failed", String(telemetryError));
            }

            let unitPath = event.slot.getAdUnitPath(); //get the ad unith path for the slot which will render the ad
            let stickyBackground = document.getElementById('adhesion_background'); //get the adhesion background id
            //let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; //check user's screen width

            if (unitPath === adUnitPath + "Sticky" && event.isEmpty === true) {
                let sticky = document.getElementById('Adhesion');
                sticky.style.display = 'none';
            }

            // if ad unit is sticky and the background is not set, set sticky CSS for sticky ad unit
            else if (unitPath === adUnitPath + "Sticky" && stickyBackground === null){
            let sticky = document.getElementById('Adhesion');
            sticky.style.position = 'fixed';
            sticky.style.zIndex = '999999';
            sticky.style.width = '100%';
            sticky.style.height = '';
            sticky.style.bottom = '0px';
            sticky.style.textAlign = 'center';	
            sticky.style.padding = '10px 0px 0px';
            sticky.style.borderTop = '1px #CCC solid';
            
            // create adhesion background
            let background = document.createElement("div");
            background.setAttribute("ID", "adhesion_background");
            background.style.backgroundColor = '#FFF';
            
            if (adWindowWidth > 1024) {
                background.style.opacity = '70%';
            }

            else {
                background.style.opacity = '100%';
            }

            background.style.position = 'absolute';
            background.style.height = '100%';
            background.style.width = '100%';
            background.style.top = '0';
            background.style.left = '0';
            background.style.zIndex = '-1';
            sticky.appendChild(background);

            // create placeholder text
            /*let placeholder = document.createElement("div");
            placeholder.setAttribute("ID", "adText");
            placeholder.style.textAlign = 'center';
            placeholder.style.fontSize = '10px';
            placeholder.style.color = '#CCC';
            placeholder.style.height = '20px';
            placeholder.style.borderTop = '1px #CCC solid';
            placeholder.style.paddingTop = '2px';
            placeholder.textContent = 'Oglas'
            background.appendChild(placeholder);*/
        
            // create close button with svg elements
            let closeButton = document.createElement("div");
            closeButton.setAttribute("ID", "close_adhesion")
            closeButton.style.position = 'absolute';
            closeButton.style.top = '-29px';
            closeButton.style.right = '0px';
            closeButton.style.cursor = 'pointer';
            closeButton.style.padding = '8px';
            //closeButton.style.borderRadius = '50%';
            closeButton.style.border = '1px solid #CCC';
            //closeButton.style.boxShadow = '0 0 3px #b8b9be';
            closeButton.style.background = '#FFF';
            closeButton.style.borderBottom = '1px solid #FFF';
            closeButton.style.borderTopLeftRadius = '10px';
            
            let iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            let iconPath = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'path'
            );

            iconSvg.setAttribute('display', 'block');
            iconSvg.setAttribute('fill', '#000');
            iconSvg.setAttribute('width', '12px');
            iconSvg.setAttribute('height', '12px');
            iconSvg.setAttribute('viewBox', '0 0 8 8');

            iconPath.setAttribute(
                'd',
                'M1.41 0l-1.41 1.41.72.72 1.78 1.81-1.78 1.78-.72.69 1.41 1.44.72-.72 1.81-1.81 1.78 1.81.69.72 1.44-1.44-.72-.69-1.81-1.78 1.81-1.81.72-.72-1.44-1.41-.69.72-1.78 1.78-1.81-1.78-.72-.72z'
            );
            
            iconSvg.appendChild(iconPath);
            closeButton.appendChild(iconSvg); 
            sticky.appendChild(closeButton);
            
            // when user clicks the close button, remove the sticky div
            document.getElementById("close_adhesion").addEventListener('click', function(e) {
                e.preventDefault();
                sticky.parentNode.removeChild(sticky);
            }, false); 


            } 
        });
        
        // Check if adsKeywords object is present
        if (typeof adsKeywords != 'undefined') {

            // Check if adsKeywords attributes are present, if so, pass them as key values to GAM
            if (typeof adsKeywords.category != 'undefined') {
                googletag.pubads().setTargeting('category', adsKeywords.category);
            } 

            if (typeof adsKeywords.subcategory != 'undefined') {
                googletag.pubads().setTargeting('subcategory', adsKeywords.subcategory);
            } 

            if (typeof adsKeywords.pageType != 'undefined') {
                googletag.pubads().setTargeting('pageType', adsKeywords.pageType);
            } 

            if (typeof adsKeywords.articleUuid != 'undefined') {
                googletag.pubads().setTargeting('articleId', [adsKeywords.articleUuid].join(','));
            } 
            
            if (typeof adsKeywords.articleTags != 'undefined') {
                googletag.pubads().setTargeting('articleTags', [adsKeywords.articleTags].join(','));
            } 
        }

        let adQueryString = window.location.search; // Get the whole string in the URL. 
        //console.log("Query string is " + adQueryString);

        let adUrlParams = new URLSearchParams(adQueryString); // Get the information after ? in the URL. 
        //console.log("URL param is " +  adUrlParams);

        if (adUrlParams.has('adTest')) { 
            let adValue = adUrlParams.get('adTest'); // If there is a adTest param get the value after =. 
            //console.log("AdTest value is " + adValue);
            googletag.pubads().setTargeting('adTest', adValue); // Send the adTest value to GAM.
        } 

        if (adUrlParams.has('utm_source')) {
            let utmSource = adUrlParams.get('utm_source'); // If there is a utm_source param get the value after =. 
            //console.log("UTM source value is " + utmSource);
            googletag.pubads().setTargeting('utmSource', utmSource); // Send the utm_source value to GAM.
        } 

        if (adUrlParams.has('utm_medium')) {
            let utmMedium = adUrlParams.get('utm_medium'); // If there is a utm_medium param get the value after =. 
            //console.log("UTM medium value is " + utmMedium);
            googletag.pubads().setTargeting('utmMedium', utmMedium); // Send the utm_medium value to GAM.
        } 

        let refURL = document.referrer; // Get the URL from which the user came. 

        if (refURL.length === 0) {
            googletag.pubads().setTargeting('referrer', 'direct');
        } 

        else if (refURL.includes("google")) {
            googletag.pubads().setTargeting('referrer', 'google');
        } 
          
        else if (refURL.includes("linkedin") || refURL.includes("t.com") || refURL.includes("facebook") || refURL.includes("instagram")) {
            googletag.pubads().setTargeting('referrer', 'social');
        } 
          
        else if (refURL.includes("blic.rs") || refURL.includes("pulsonline.rs") || refURL.includes("ana.rs") || refURL.includes("nekretnine.rs") || refURL.includes("mojauto.rs")) {
            googletag.pubads().setTargeting('referrer', 'ringier');
        } 
          
        else {
            googletag.pubads().setTargeting('referrer', 'other');
        }

        

        // CX targeting
        if(typeof window.localStorage === 'object' && typeof window.localStorage.getItem === 'function' && localStorage.getItem("CxSegments") !== null && localStorage.getItem("CxSegments").length>0) {
            googletag.pubads().setTargeting('CxSegments', localStorage.getItem('CxSegments').split(','));
        }

        if(typeof window.localStorage === 'object' && typeof window.localStorage.getItem === 'function' && localStorage.getItem("CxCmbnd") !== null && localStorage.getItem("CxCmbnd").length>0) {
            googletag.pubads().setTargeting('CxCmbnd', localStorage.getItem('CxCmbnd').split(','))
        }

        // **************** 22092026: web interstitial GPT slot + Prebid ad unit. *******************
        // Outside the adContainers loop on purpose: there is no ".wrapperAd" div for it,
        // GPT renders the interstitial in its own full-screen container.
        if (INTERSTITIAL_PREBID_ENABLED === true) {
            defineInterstitialSlotAndPrebidAdUnit();
        } else {
            window.__zenaInterstitialState.reason = 'disabled';
        }

        googletag.pubads().disableInitialLoad(); // Disables requests for ads on page load. 
        googletag.pubads().enableSingleRequest(); // Enables single request mode for fetching multiple ads at the same time.
        googletag.pubads().setCentering(true);
        googletag.enableServices(); // Enables all GPT services that have been defined for ad slots on the page.

        // Get the list of slots associated with this service.
        googletag.pubads().getSlots().forEach(function(adSlots) {
            // 22092026: the web interstitial is an out-of-page slot without a div; display()
            // takes the slot object itself for those.
            if (adSlots.getOutOfPage && adSlots.getOutOfPage()) {
                googletag.display(adSlots);
                return;
            }
            googletag.display(adSlots.getSlotElementId()); // Instructs slot services to render all of the defined ad slots. 
        });

    });

    pbjs.que.push(function() {

        pbjs.aliasBidder('adf', 'mediapool', {gvlid:50});
    
        pbjs.setConfig({
    
            priceGranularity: 'high', //$0.01 increments, up to $20

            enableSendAllBids: false, //send only top bids
            targetingControls: {
              alwaysIncludeDeals: true //send all deal bids
            },
    
            //Currency module
            currency: {
                "adServerCurrency": "EUR",
                "conversionRateFile": "https://cdn.jsdelivr.net/gh/prebid/currency-file@1/latest.json",
             },
    
            //Coockie match and user syncs
            userSync: {
                syncEnabled: true,
                syncsPerBidder: 5,
                syncDelay: 3000,
                auctionDelay: 50,
                userIds: [
    
                    { name: "sharedId", 
                      storage: { type: "cookie", name: "_sharedid", expires: 365 } 
                    },
    
                    { name: "id5Id",
                        params: { partner: 1355, externalModuleUrl: 'https://cdn.id5-sync.com/api/1.0/id5PrebidModule.js' },
                        storage: { type: "html5", name: "id5id", expires: 90, refreshInSeconds: 8*3600 }
                    },
    
                    { name: 'teadsId',
                      params: { pubId: 26849 }
                    },
    
                    { name: 'lotamePanoramaId',
                    },
    
                ],
                aliasSyncEnabled: true,
                filterSettings: { all: { bidders: "*", filter: "include" } },
            },

            enableTIDs: true,

            // defaultGdprScope is deliberately false: if the CMP never answers
            // (and even the TCF watchdog at the top of this file somehow fails
            // to take over), Prebid proceeds after the timeout treating GDPR as
            // not applying, which is the correct resolution for this site's
            // non-EEA (Serbian) audience. With defaultGdprScope true, a stuck
            // CMP means "GDPR applies with zero consent" and every auction
            // dies — that is exactly the failure mode that took the site's ads
            // down on 03.09.2026.
            consentManagement: {
                gdpr: {
                  cmpApi: 'iab',
                  timeout: 8000,
                  defaultGdprScope: false
                }
            },

            /*paapi: {
                enabled: true,
                gpt: {
                    autoconfig: false
                },
                defaultForSlots: 1
            },*/
            
            //useBidCache: true,

        });

        pbjs.bidderSettings = {
            standard: {
                storageAllowed: true,
            },

            // Taboola requires localStorage access for its own bidder. The standard
            // block above already grants it to every bidder, so this entry is
            // redundant today, but Taboola asks for it per-bidder and declaring it
            // explicitly keeps the requirement visible if the standard default is
            // ever tightened.
            //
            // The key must be lowercase 'taboola' so that it matches the bidder code
            // used in the ad units. Taboola's own documentation writes it as
            // bidderSettings["Taboola"], which would silently never apply, because
            // Prebid matches these keys against the bidder code exactly.
            taboola: {
                storageAllowed: true,

                // Convert Taboola's bids from gross to net with a 0.75 multiplier.
                //
                // Taboola states this is required whenever every other SSP in the
                // setup already bids net, and that is the case here: adf and its
                // mediapool alias declare priceType 'net' explicitly on every
                // placement, and the rest of the Zena stack was confirmed to bid net
                // on 24.08.2026 -- the same finding that prompted the identical
                // change on Blic.rs on the same day.
                //
                // Without this multiplier Taboola's gross bids sit roughly 33% high
                // against every other bidder, so Taboola wins auctions it should lose
                // and displaces demand that is genuinely worth more. A bidder winning
                // on an inflated bid looks like strong performance in reporting while
                // actually costing money, which is what makes this easy to miss:
                // Taboola's measured 12.0% share of top bids on Zena (22 days to
                // 18.08.2026) was produced WITHOUT this adjustment and is therefore
                // overstated. Expect its win share to fall after this change; that is
                // the correction working, not a regression.
                //
                // If the stack ever moves to gross bidding, this multiplier must be
                // removed at the same time, or Taboola will be penalised by 25%.
                bidCpmAdjustment: function (bidCpm) {
                    return bidCpm * 0.75;
                },
            },
        }; 
        
    
        //Add only ATF ad units.
        pbjs.addAdUnits(adUnitsATF);
        
        //Request bids.
        // Request bids (Billboard uses a shorter timeout).
        var atfAdUnitCodes = adUnitsATF.map(function (adUnit) { return adUnit.code; });

        var atfBillboardCodes = atfAdUnitCodes.filter(function (code) { return code === 'Billboard'; });
        var atfNonBillboardCodes = atfAdUnitCodes.filter(function (code) { return code !== 'Billboard'; });

        // Telemetry (15092026): the first Prebid auction of the page is about to
        // be requested (Prebid's consent module may still hold it internally).
        recordFirstRequestMilestone('firstRequestBidsMs');

        if (atfBillboardCodes.length > 0) {
            pbjs.requestBids({
                adUnitCodes: atfBillboardCodes,
                bidsBackHandler: initBillboardAdserver,
                timeout: getPrebidTimeoutForAdUnit('Billboard')
            });
        }

        // 07102026: while the fast path's synthetic answer (empty consent
        // string) is in force, In_Text_1 leaves the first-screen batch and
        // waits for the real consent answer (see IN_TEXT_1 REAL-CONSENT HOLD).
        var inText1IsHeld = shouldHoldInText1(atfNonBillboardCodes);
        if (inText1IsHeld) {
            atfNonBillboardCodes = atfNonBillboardCodes.filter(function (code) { return code !== IN_TEXT_1_HOLD_AD_UNIT_CODE; });
        }

        if (atfNonBillboardCodes.length > 0) {
            pbjs.requestBids({
                adUnitCodes: atfNonBillboardCodes,
                bidsBackHandler: function () { initNonBillboardAdserver(atfNonBillboardCodes); },
                timeout: PREBID_TIMEOUT
            });
        }

        if (atfBillboardCodes.length === 0 && atfNonBillboardCodes.length === 0) {
            initNonBillboardAdserver([]);
        }

        // 07102026: In_Text_1 was the only first-screen unit next to the
        // Billboard. The GPT-only slots (Adhesion, Branding) still get their
        // first request at once, as they did after the batch auction.
        if (inText1IsHeld && atfBillboardCodes.length > 0 && atfNonBillboardCodes.length === 0) {
            initNonBillboardAdserver([]);
        }

        if (inText1IsHeld) {
            startInText1RealConsentHold();
        }

        // 22092026: the interstitial's own Prebid auction, dispatched after the first-screen
        // auctions above. adUnitsInterstitial is filled by defineInterstitialSlotAndPrebidAdUnit()
        // in the GPT command queue (same relationship as adUnitsATF); empty = no slot on this page.
        if (INTERSTITIAL_PREBID_ENABLED === true && adUnitsInterstitial.length > 0 && interstitialPrebidAdUnitCode) {
            pbjs.addAdUnits(adUnitsInterstitial);
            window.__zenaInterstitialState.auctionRequested = true;
            pbjs.requestBids({
                adUnitCodes: [interstitialPrebidAdUnitCode],
                bidsBackHandler: initInterstitialAdserver,
                timeout: PREBID_TIMEOUT
            });
        }
});

    // Send requests to the SSPs and send bids to GAM for the Billboard slot first.
    function initBillboardAdserver() {
        if (pbjs.billboardInitAdserverSet) return;
        pbjs.billboardInitAdserverSet = true;

        googletag.cmd.push(function () {
            pbjs.que.push(function () {
                // Do NOT wait for user IDs / PPID here (speed first).
                pbjs.setTargetingForGPTAsync(['Billboard']);
                // Telemetry (15092026): page-level timing key-values must be
                // set before the first ad request leaves the page.
                recordFirstRequestTelemetryBeforeRefresh('Billboard');
                googletag.pubads().refresh([Billboard]);
});
        });
    }

    // 22092026: define the web interstitial GPT slot and its Prebid ad unit.
    // Runs inside the GPT command queue, after the div-driven slot definitions
    // and before enableServices(). Fills adUnitsInterstitial for the Prebid side.
    function defineInterstitialSlotAndPrebidAdUnit() {
        var interstitialState = window.__zenaInterstitialState;
        var interstitialAdUnitPath = adUnitPath + INTERSTITIAL_GAM_AD_UNIT_LEAF;

        try {
            // GPT must expose the out-of-page format enum.
            if (!googletag.enums || !googletag.enums.OutOfPageFormat || googletag.enums.OutOfPageFormat.INTERSTITIAL === undefined) {
                interstitialState.reason = 'gpt_no_interstitial_enum';
                adsDebugLog('[ads-interstitial] GPT has no INTERSTITIAL out-of-page format; skipped.');
                return;
            }

            // GPT allows ONE web interstitial per page. If GPT already holds one on this ad
            // unit path (GAM's automatic "codeless" interstitial), leave it alone: no second
            // slot, no auction.
            var existingSlots = googletag.pubads().getSlots();
            for (var existingIndex = 0; existingIndex < existingSlots.length; existingIndex++) {
                var existingSlot = existingSlots[existingIndex];
                if (existingSlot && existingSlot.getOutOfPage && existingSlot.getOutOfPage() &&
                    existingSlot.getAdUnitPath && existingSlot.getAdUnitPath() === interstitialAdUnitPath) {
                    interstitialState.reason = 'gpt_already_has_interstitial';
                    adsDebugLog('[ads-interstitial] GPT already holds an interstitial on ' + interstitialAdUnitPath + '; wrapper slot skipped.');
                    return;
                }
            }

            Interstitial = googletag.defineOutOfPageSlot(interstitialAdUnitPath, googletag.enums.OutOfPageFormat.INTERSTITIAL);

            if (!Interstitial) {
                interstitialState.reason = 'gpt_refused_slot';
                adsDebugLog('[ads-interstitial] GPT refused the interstitial slot in this context (null returned).');
                return;
            }

            Interstitial.setTargeting('position', 'Interstitial')
                        .setTargeting('refresh_count', '0')
                        .setTargeting('refresh_bucket', getRefreshBucket(0))
                        .addService(googletag.pubads());

            interstitialPrebidAdUnitCode = Interstitial.getSlotElementId();

            adUnitsInterstitial.push(
                {   code: interstitialPrebidAdUnitCode,
                    mediaTypes: {banner: {
                        // 300x250 + 336x280 on every viewport (both are hb_pb line item placeholder sizes and
                        // Google-supported interstitial sizes); the 320x480 portrait size only below 1024 px.
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop
                            { minViewPort: [0, 0], sizes: [[300, 250], [336, 280], [320, 480]] }, //tablet + mobile
                        ]
                    }},
                    // OpenRTB interstitial flag, read by adapters that forward it. The adf adapter does
                    // not; Adform knows the format from the placement configuration of this mid.
                    ortb2Imp: { instl: 1 },
                    bids: [
                        { bidder: 'adf', params: { mid: INTERSTITIAL_ADFORM_MID, priceType: 'net' } },
                    ]
                }
            );

            interstitialState.defined = true;
            interstitialState.slotElementId = interstitialPrebidAdUnitCode;
            interstitialState.reason = 'defined';
            adsDebugLog('[ads-interstitial] GPT web interstitial slot defined', {
                adUnitPath: interstitialAdUnitPath,
                slotElementId: interstitialPrebidAdUnitCode
            });
        } catch (error) {
            interstitialState.reason = 'define_failed';
            adsDebugLog('[ads-interstitial] define failed', String(error));
        }
    }

    // 22092026: bidsBackHandler of the interstitial's own auction. Sends the Prebid
    // result and the aq_* auction-quality keys to the GPT slot, then requests the
    // interstitial from GAM (its only request on the page; it is never refreshed).
    function initInterstitialAdserver(bidResponses, timedOut, auctionId) {
        if (pbjs.interstitialInitAdserverSet) return;
        pbjs.interstitialInitAdserverSet = true;

        var interstitialState = window.__zenaInterstitialState;
        interstitialState.auctionAnswered = true;

        googletag.cmd.push(function () {
            pbjs.que.push(function () {
                if (!Interstitial || !interstitialPrebidAdUnitCode) {
                    return;
                }

                try {
                    pbjs.setTargetingForGPTAsync([interstitialPrebidAdUnitCode]);
                } catch (error) {
                    adsDebugLog('[ads-interstitial] setTargetingForGPTAsync failed', String(error));
                }

                // aq_* keys of this auction on the slot: bid depth and top bid bucket are
                // reportable in GAM per ad unit even when the bid loses at the ad server.
                try {
                    var interstitialAuctionQuality = collectAuctionQuality(interstitialPrebidAdUnitCode, bidResponses, timedOut, auctionId);
                    applyAuctionQualityTargeting(Interstitial, interstitialAuctionQuality);
                    interstitialState.bidCount = interstitialAuctionQuality.validBidCount;
                    interstitialState.topBidCpm = interstitialAuctionQuality.highestBidCpm;
                } catch (error) {
                    adsDebugLog('[ads-interstitial] auction-quality targeting failed', String(error));
                }

                // Telemetry: the first-request key is set by whichever first-screen request
                // left the page first; this call only upgrades a pending aq_consent_wait.
                recordFirstRequestTelemetryBeforeRefresh('Interstitial');

                interstitialState.gptRequested = true;
                googletag.pubads().refresh([Interstitial]);
            });
        });
    }

// Send requests to the SSPs and send bids to GAM for the ATF slots.
    function initNonBillboardAdserver(atfNonBillboardCodes) {
        if (pbjs.nonBillboardInitAdserverSet) return;
        pbjs.nonBillboardInitAdserverSet = true;
        googletag.cmd.push(function() {
            pbjs.que.push(function() {

                pbjs.getUserIdsAsync().then(function (userIds) {

                    var ppid;

                    try {
                        // pick up the PPID from local storage
                        ppid = JSON.parse(decodeURIComponent(window.localStorage.getItem('id5id'))).gp;

                        // pass the “gp” ID as PPID to GPT tag
                        if (ppid) {
                           googletag.pubads().setPublisherProvidedId(ppid); 
                        }

                       /* else {
                            console.log('ppid is not defined');
                        } */
                        
                    }

                    catch {
                        //console.log('gp is not defined');
                    }

                    pbjs.setTargetingForGPTAsync();
                    //pbjs.setPAAPIConfigForGPT();
                    var initialSlotsToRefresh = [Adhesion, P1];

                    // 07102026: a held In_Text_1 gets its first request from
                    // the IN_TEXT_1 REAL-CONSENT HOLD instead.
                    if (inText1HoldState.held !== true) {
                        initialSlotsToRefresh.push(In_Text_1);
                    }

                    // Branding slots are desktop-only and may not be defined on smaller viewports.
                    if (typeof Branding_Left !== 'undefined' && Branding_Left) {
                        initialSlotsToRefresh.push(Branding_Left);
                    }

                    if (typeof Branding_Right !== 'undefined' && Branding_Right) {
                        initialSlotsToRefresh.push(Branding_Right);
                    }

                    // Telemetry (15092026): first request if the Billboard slot is
                    // absent on this page; otherwise only upgrades a pending
                    // consent-wait value.
                    recordFirstRequestTelemetryBeforeRefresh('ATF');
                    googletag.pubads().refresh(initialSlotsToRefresh);

                });

            });
        });
    };
/*
    
    // ---------------------------------------------------------------------
    // BILLBOARD TIMED REFRESH (30s)
    //
    // Purpose:
    // - Ensure Billboard gets another auction after 30 seconds even if the
    //   user scrolls away (i.e. without requiring the viewability threshold).
    // - Uses the same safeguards as the viewability refresh:
    //     * respects GAM_NOREFRESH_* lists
    //     * respects MAX_REFRESH_COUNT_PER_SLOT via refresh_count targeting
    //     * avoids overlapping refreshes
    // ---------------------------------------------------------------------

    var billboardTimedRefreshTimerId = null;
    var billboardTimedRefreshInFlight = false;

    function scheduleBillboardTimedRefresh() {
        try {
            if (billboardTimedRefreshTimerId !== null) {
                return; // already scheduled
            }
            billboardTimedRefreshTimerId = setTimeout(function () {
                billboardTimedRefreshTimerId = null;
                attemptBillboardTimedRefresh();
            }, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
        } catch (error) {
            // ignore
        }
    }

    function attemptBillboardTimedRefresh() {
        if (billboardTimedRefreshInFlight) {
            return;
        }

        // Respect "no refresh" list if someone adds Billboard back later.
        if (typeof GAM_NOREFRESH_ADUNITS !== "undefined" && GAM_NOREFRESH_ADUNITS.indexOf("Billboard") !== -1) {
            return;
        }

        billboardTimedRefreshInFlight = true;

        googletag.cmd.push(function () {
            var allSlots;
            try {
                allSlots = googletag.pubads().getSlots();
            } catch (e) {
                billboardTimedRefreshInFlight = false;
                scheduleBillboardTimedRefresh();
                return;
            }

            var gptSlot = resolveGptSlotByDivId(allSlots, "Billboard");
            if (!gptSlot) {
                billboardTimedRefreshInFlight = false;
                scheduleBillboardTimedRefresh();
                return;
            }

            // Read current refresh_count (defaults to 0).
            var refreshCount = 0;
            try {
                var refreshCountTargeting = gptSlot.getTargeting("refresh_count");
                refreshCount = parseInt((refreshCountTargeting && refreshCountTargeting[0]) || "0", 10);
                if (isNaN(refreshCount)) refreshCount = 0;
            } catch (e) {
                refreshCount = 0;
            }

            var maxRefresh = (typeof MAX_REFRESH_COUNT_PER_SLOT === "number" && MAX_REFRESH_COUNT_PER_SLOT >= 0)
                ? MAX_REFRESH_COUNT_PER_SLOT
                : 4;

            if (refreshCount >= maxRefresh) {
                billboardTimedRefreshInFlight = false;
                return;
            }

            // Skip refresh for excluded advertisers (if we can read it).
            var advertiserID;
            try {
                var responseInformation = gptSlot.getResponseInformation && gptSlot.getResponseInformation();
                advertiserID = responseInformation && responseInformation.advertiserId;
            } catch (e) {
                advertiserID = undefined;
            }

            if (typeof GAM_NOREFRESH_ADVERTISER_IDS !== "undefined" && GAM_NOREFRESH_ADVERTISER_IDS.indexOf(advertiserID) !== -1) {
                billboardTimedRefreshInFlight = false;
                scheduleBillboardTimedRefresh();
                return;
            }

            // Run a fresh HB auction for Billboard and refresh it.
            pbjs.que.push(function () {
                pbjs.requestBids({
                    timeout: getPrebidTimeoutForAdUnit("Billboard"),
                    adUnitCodes: ["Billboard"],
                    bidsBackHandler: function () {
                        pbjs.setTargetingForGPTAsync(["Billboard"]);

                        googletag.cmd.push(function () {
                            var nextRefreshCount = refreshCount + 1;
                            gptSlot.setTargeting("refresh_count", String(nextRefreshCount));
                            gptSlot.setTargeting("refresh_bucket", getRefreshBucket(nextRefreshCount));
                            googletag.pubads().refresh([gptSlot]);
                        });

                        billboardTimedRefreshInFlight = false;

                        // schedule the next timed refresh window (recurring) until max refreshes.
                        scheduleBillboardTimedRefresh();
                    }
                });
            });
        });
    }
*/
/*
// ---------------------------------------------------------------------
// BILLBOARD TIMED REFRESH (GATED BY VIEWABILITY)
//
// Purpose:
// - Give Billboard a second chance after ~30s, BUT only if it is currently
//   >= VISIBILITY_PERCENT_FOR_REFRESH viewable.
// - This keeps Billboard aligned with the "only refresh when viewable" rule,
//   while preserving the revenue uplift seen with timed refresh.
// ---------------------------------------------------------------------

var billboardTimedRefreshTimerId = null;
var billboardTimedRefreshInFlight = false;

function scheduleBillboardGatedTimedRefresh() {
    try {
        if (billboardTimedRefreshTimerId !== null) {
            return;
        }
        billboardTimedRefreshTimerId = setTimeout(function () {
            billboardTimedRefreshTimerId = null;
            attemptBillboardGatedTimedRefresh();
        }, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
    } catch (error) {
        // ignore
    }
}

function attemptBillboardGatedTimedRefresh() {
    if (billboardTimedRefreshInFlight) {
        return;
    }

    billboardTimedRefreshInFlight = true;

    // Gate on viewability using the same refresh state as other slots.
    try {
        var billboardState = refreshStateByDivId && refreshStateByDivId.get ? refreshStateByDivId.get("Billboard") : null;
        var ratio = billboardState ? (billboardState.lastIntersectionRatio || 0) : 0;

        if (ratio < VISIBILITY_PERCENT_FOR_REFRESH) {
            billboardTimedRefreshInFlight = false;
            scheduleBillboardGatedTimedRefresh();
            return;
        }
    } catch (error) {
        billboardTimedRefreshInFlight = false;
        scheduleBillboardGatedTimedRefresh();
        return;
    }

    if (typeof GAM_NOREFRESH_ADUNITS !== "undefined" && GAM_NOREFRESH_ADUNITS.indexOf("Billboard") !== -1) {
        billboardTimedRefreshInFlight = false;
        return;
    }

    googletag.cmd.push(function () {
        var allSlots;
        try {
            allSlots = googletag.pubads().getSlots();
        } catch (e) {
            billboardTimedRefreshInFlight = false;
            scheduleBillboardGatedTimedRefresh();
            return;
        }

        var gptSlot = resolveGptSlotByDivId(allSlots, "Billboard");
        if (!gptSlot) {
            billboardTimedRefreshInFlight = false;
            scheduleBillboardGatedTimedRefresh();
            return;
        }

        var refreshCount = 0;
        try {
            var refreshCountTargeting = gptSlot.getTargeting("refresh_count");
            refreshCount = parseInt((refreshCountTargeting && refreshCountTargeting[0]) || "0", 10);
            if (isNaN(refreshCount)) refreshCount = 0;
        } catch (e) {
            refreshCount = 0;
        }

        if (typeof MAX_REFRESH_COUNT_PER_SLOT === "number" && MAX_REFRESH_COUNT_PER_SLOT >= 0 && refreshCount >= MAX_REFRESH_COUNT_PER_SLOT) {
            billboardTimedRefreshInFlight = false;
            return;
        }

        var advertiserID;
        try {
            var responseInformation = gptSlot.getResponseInformation && gptSlot.getResponseInformation();
            advertiserID = responseInformation && responseInformation.advertiserId;
        } catch (e) {
            advertiserID = undefined;
        }

        if (typeof GAM_NOREFRESH_ADVERTISER_IDS !== "undefined" && GAM_NOREFRESH_ADVERTISER_IDS.indexOf(advertiserID) !== -1) {
            billboardTimedRefreshInFlight = false;
            scheduleBillboardGatedTimedRefresh();
            return;
        }

        pbjs.que.push(function () {
            pbjs.requestBids({
                timeout: getPrebidTimeoutForAdUnit("Billboard"),
                adUnitCodes: ["Billboard"],
                bidsBackHandler: function () {
                    pbjs.setTargetingForGPTAsync(["Billboard"]);

                    googletag.cmd.push(function () {
                        var nextRefreshCount = refreshCount + 1;
                        gptSlot.setTargeting("refresh_count", String(nextRefreshCount));
                            gptSlot.setTargeting("refresh_bucket", getRefreshBucket(nextRefreshCount));
                        googletag.pubads().refresh([gptSlot]);
                    });

                    billboardTimedRefreshInFlight = false;
                    scheduleBillboardGatedTimedRefresh();
                }
            });
        });
    });
}
*/



//Add BTF ad units.
    pbjs.que.push(function() {
        pbjs.addAdUnits(adUnitsBTF);
    });

    // Use IntersectionObserver API to check whether an ad slot is at the certain distance. 
    var observer = new IntersectionObserver (function(entries) {

        entries.forEach(entry => {

            if (entry.isIntersecting) {

                let adSlot = entry.target.id; // Get the div id of the slot being observed. 

                // Request bids and push the ads to GAM. 
                pbjs.que.push(function() {
                    pbjs.requestBids({
                        timeout: PREBID_TIMEOUT,
                        adUnitCodes: [adSlot],
                        bidsBackHandler: function() {
                            pbjs.setTargetingForGPTAsync([adSlot]);
    
                            // If div with the certain ID is present and observed, refresh GAM slot.
                            if (adSlot === 'Billboard_2') {
                                googletag.pubads().refresh([Billboard_2]); 
                            } 

                            else if (adSlot === 'Billboard_3') {
                                googletag.pubads().refresh([Billboard_3]); 
                            } 

                            else if (adSlot === 'Billboard_4') {
                                googletag.pubads().refresh([Billboard_4]); 
                            } 

                            else if (adSlot === 'Billboard_5') {
                                googletag.pubads().refresh([Billboard_5]); 
                            } 

                            else if (adSlot === 'P2') {
                                googletag.pubads().refresh([P2]); 
                            } 
        
                            else if (adSlot === 'P3') {
                                googletag.pubads().refresh([P3]); 
                            } 
                            
                            else if (adSlot === 'P4') {
                                googletag.pubads().refresh([P4]); 
                            } 

                            else if (adSlot === 'P5') {
                                googletag.pubads().refresh([P5]); 
                            } 

                            else if (adSlot === 'P6') {
                                googletag.pubads().refresh([P6]); 
                            } 

                            else if (adSlot === 'In_Text_2') {
                                googletag.pubads().refresh([In_Text_2]); 
                            } 

                            else if (adSlot === 'In_Text_3') {
                                googletag.pubads().refresh([In_Text_3]); 
                            } 

                            else if (adSlot === 'In_Text_4') {
                                googletag.pubads().refresh([In_Text_4]); 
                            } 

                            else if (adSlot === 'In_Text_5') {
                                googletag.pubads().refresh([In_Text_5]); 
                            } 

                            else if (adSlot === 'In_Text_6') {
                                googletag.pubads().refresh([In_Text_6]); 
                            } 

                            else if (adSlot === 'In_Text_7') {
                                googletag.pubads().refresh([In_Text_7]); 
                            } 

                            else if (adSlot === 'In_Text_8') {
                                googletag.pubads().refresh([In_Text_8]); 
                            } 

                            else if (adSlot === 'In_Text_9') {
                                googletag.pubads().refresh([In_Text_9]); 
                            } 

                            else if (adSlot === 'In_Text_10') {
                                googletag.pubads().refresh([In_Text_10]); 
                            } 

                        }
                    });
                });
                
                // -------------------------------------------------------------
                // Register this lazily-loaded slot for viewability-based refresh.
                //
                // The refresh observer is initialized once from currently-defined
                // GPT slots. Below-the-fold slots (like P5) are defined later, so
                // we must begin observing them here, right after they are loaded.
                // -------------------------------------------------------------
                try {
                    if (typeof viewabilityObserver !== "undefined" && viewabilityObserver && entry.target) {
                        getOrCreateRefreshState(adSlot);
                        viewabilityObserver.observe(entry.target);
                        adsDebugLog("[ads-refresh]", adSlot, "refresh_observer_attached_from_lazy_load");
                    }
                } catch (error) {
                    adsDebugLog("[ads-refresh]", adSlot, "refresh_observer_attach_failed", { error: String(error) });
                }

observer.unobserve(entry.target); // Stop observing the ad slot which has alredy been seen. 
            }
        })
    }, {rootMargin: DISTANCE_IN_PIXELS_FOR_LAZY_LOADING}); // Distance to the ad slot.

    document.querySelectorAll('.lazyAd').forEach(slots => { observer.observe(slots) }); // Check all divs with the class lazyAd and observe them all. 

    
    
    // ---------------------------------------------------------------------
    
    // ---------------------------------------------------------------------
    // VIEWABILITY-BASED REFRESH (HIGH PRIORITY FIXES)
    //
    // Goals:
    //  1) Use intersectionRatio (not isIntersecting) to represent "X% viewable" correctly.
    //  2) Require the slot to stay >= VISIBILITY_PERCENT_FOR_REFRESH for the
    //     advertiser-specific refresh interval before refreshing.
    //  3) Pause + reset the continuous timer when the tab is hidden.
    //  4) Enforce a hard MIN_REFRESH_INTERVAL_MS per slot (defensive throttle).
    //  5) Cap refresh_count at MAX_REFRESH_COUNT_PER_SLOT for A/B testing.
    //
    // Nothing else about auctions, bidders, or lazy loading is changed.
    // ---------------------------------------------------------------------

    // Max refreshes for all slots. null preserves the current unlimited behavior.
    var MAX_REFRESH_COUNT_PER_SLOT = null;

    // Hard per-slot minimum interval (ms). We set it equal to the continuous viewability
    // wait time to preserve the existing cadence while protecting against double triggers.
    var MIN_REFRESH_INTERVAL_MS = SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000; // legacy debug baseline; runtime uses getRefreshIntervalSeconds()

    // Per-slot refresh state keyed by div id.
    var refreshStateByDivId = new Map();

    function getOrCreateRefreshState(divId) {
        if (refreshStateByDivId.has(divId)) {
            return refreshStateByDivId.get(divId);
        }

        var initialState = {
            divId: divId,
            isAboveVisibilityThreshold: false,
            lastIntersectionRatio: 0,
            continuousViewabilityStartTimestamp: null,
            lastRefreshTimestamp: 0,
            scheduledRefreshTimeoutId: null,
            // Cumulative timer state (used only when USE_CUMULATIVE_VIEWABILITY_TIMER is true)
            cumulativeViewableMs: 0,
            lastAboveThresholdTimestamp: null,
            currentRefreshCount: 0,
            lastAuctionQuality: null,
            lastRenderResult: null,
            auctionQualityHistory: []
        };

        refreshStateByDivId.set(divId, initialState);
        return initialState;
    }

    function clearScheduledRefresh(divId) {
        var state = refreshStateByDivId.get(divId);
        if (!state) {
            return;
        }
        if (state.scheduledRefreshTimeoutId !== null) {
            clearTimeout(state.scheduledRefreshTimeoutId);
            state.scheduledRefreshTimeoutId = null;
        }
    }

    function scheduleRefreshWindowFromNow(divId) {
    var state = refreshStateByDivId.get(divId);
    if (!state) {
        return;
    }

    if (document.visibilityState !== "visible") {
        adsDebugLog("[ads-refresh]", divId, "skip schedule: tab_hidden");
        return;
    }

    if (!state.isAboveVisibilityThreshold) {
        adsDebugLog(
            "[ads-refresh]",
            divId,
            "skip schedule: below_threshold",
            { ratio: state.lastIntersectionRatio }
        );
        return;
    }

    clearScheduledRefresh(divId);

    var refreshIntervalSeconds = getRefreshIntervalSeconds(divId);
    var refreshIntervalMs = refreshIntervalSeconds * 1000;

    // Default (continuous) behavior: require the selected interval of uninterrupted viewability.
    if (!USE_CUMULATIVE_VIEWABILITY_TIMER) {
        state.continuousViewabilityStartTimestamp = Date.now();

        adsDebugLog(
            "[ads-refresh]",
            divId,
            "schedule refresh window (continuous)",
            { seconds: refreshIntervalSeconds, ratio: state.lastIntersectionRatio }
        );

        state.scheduledRefreshTimeoutId = setTimeout(function () {
            attemptRefresh(divId);
        }, refreshIntervalMs);

        return;
    }

    // Cumulative behavior: count viewability time across multiple segments, but require:
    // - current ratio >= VISIBILITY_PERCENT_FOR_REFRESH
    // - last continuous stretch >= MIN_CONTINUOUS_VIEWABILITY_SEGMENT_MS
    if (state.lastAboveThresholdTimestamp === null) {
        state.lastAboveThresholdTimestamp = Date.now();
    }

    var remainingMs = refreshIntervalMs - (state.cumulativeViewableMs || 0);
    if (remainingMs < 0) {
        remainingMs = 0;
    }

    // Enforce at least MIN_CONTINUOUS_VIEWABILITY_SEGMENT_MS in the current stretch.
    var waitMs = Math.max(remainingMs, MIN_CONTINUOUS_VIEWABILITY_SEGMENT_MS);

    adsDebugLog(
        "[ads-refresh]",
        divId,
        "schedule refresh window (cumulative)",
        {
            remainingMs: remainingMs,
            waitMs: waitMs,
            cumulativeMs: state.cumulativeViewableMs || 0,
            intervalSeconds: refreshIntervalSeconds,
            ratio: state.lastIntersectionRatio
        }
    );

    state.scheduledRefreshTimeoutId = setTimeout(function () {
        attemptRefresh(divId);
    }, waitMs);
}


    function pauseAllViewabilityTimersAndCancelSchedules() {
        var pauseTimestamp = Date.now();

        refreshStateByDivId.forEach(function (state) {
            if (
                USE_CUMULATIVE_VIEWABILITY_TIMER &&
                state.lastAboveThresholdTimestamp !== null
            ) {
                state.cumulativeViewableMs = (state.cumulativeViewableMs || 0) +
                    Math.max(0, pauseTimestamp - state.lastAboveThresholdTimestamp);
                state.lastAboveThresholdTimestamp = null;
            }

            state.continuousViewabilityStartTimestamp = null;
            clearScheduledRefresh(state.divId);
        });
    }

    // Expose a read-only snapshot for debugging (only when debug is enabled).
    // Access in console: window.__adsDebugState()
    if (ADS_DEBUG_ENABLED) {
        window.__adsDebugState = function () {
            try {
                var states = [];
                refreshStateByDivId.forEach(function (value, key) {
                    states.push({
                        divId: key,
                        isAboveVisibilityThreshold: Boolean(value.isAboveVisibilityThreshold),
                        lastIntersectionRatio: Number(value.lastIntersectionRatio || 0),
                        continuousViewabilityStartTimestamp: value.continuousViewabilityStartTimestamp,
                        cumulativeViewableMs: (typeof value.cumulativeViewableMs === "number") ? value.cumulativeViewableMs : null,
                        lastAboveThresholdTimestamp: value.lastAboveThresholdTimestamp || null,
                        lastRefreshTimestamp: value.lastRefreshTimestamp,
                        hasScheduledTimeout: value.scheduledRefreshTimeoutId !== null,
                        currentRefreshCount: Number(value.currentRefreshCount || 0),
                        refreshIntervalSeconds: getRefreshIntervalSeconds(key),
                        lastAuctionQuality: value.lastAuctionQuality || null,
                        lastRenderResult: value.lastRenderResult || null
                    });
                });
                return {
                    visibilityThreshold: VISIBILITY_PERCENT_FOR_REFRESH,
                    defaultRefreshIntervalSeconds: DEFAULT_REFRESH_INTERVAL_SECONDS,
                    directAdvertiserRefreshIntervalSeconds: DIRECT_ADVERTISER_REFRESH_INTERVAL_SECONDS,
                    maxRefreshCountPerSlot: MAX_REFRESH_COUNT_PER_SLOT,
                    states: states
                };
            } catch (error) {
                return { error: String(error) };
            }
        };
    }

    // Pause viewability timers when the tab is hidden.
    // When the tab becomes visible again, restart the window ONLY for slots that are
    // currently above the visibility threshold.
    document.addEventListener("visibilitychange", function () {
        if (document.visibilityState !== "visible") {
            adsDebugLog("[ads-refresh]", "tab_hidden -> pause viewability timers");
            pauseAllViewabilityTimersAndCancelSchedules();
            return;
        }

        adsDebugLog("[ads-refresh]", "tab_visible -> restart eligible timers");
        refreshStateByDivId.forEach(function (state) {
            if (state.isAboveVisibilityThreshold) {
                scheduleRefreshWindowFromNow(state.divId);
            }
        });
    });


    function getRefreshBucket(refreshCount) {
        refreshCount = parseInt(refreshCount, 10);
        if (isNaN(refreshCount) || refreshCount <= 0) {
            return "initial";
        }
        if (refreshCount <= 3) {
            return "r1_3";
        }
        return "r4_plus";
    }


    function isDirectAdvertiserId(advertiserId) {
        if (
            advertiserId === null ||
            advertiserId === undefined ||
            advertiserId === ""
        ) {
            return false;
        }

        return GAM_DIRECT_ADVERTISER_IDS.some(function (configuredId) {
            return String(configuredId) === String(advertiserId);
        });
    }

    function getCurrentRenderedAdvertiserId(divId) {
        var state = refreshStateByDivId.get(divId);
        var renderResult = state && state.lastRenderResult;
        return renderResult ? renderResult.advertiserId : null;
    }

    function getRefreshIntervalSeconds(divId) {
        var useDirectAdvertiserInterval =
            isDirectAdvertiserId(getCurrentRenderedAdvertiserId(divId));

        if (useDirectAdvertiserInterval) {
            return DIRECT_ADVERTISER_REFRESH_INTERVAL_SECONDS;
        }

        return DEFAULT_REFRESH_INTERVAL_SECONDS;
    }


// -----------------------------------------------------------------------------
// PASSIVE AUCTION-QUALITY TELEMETRY (NO DELIVERY DECISIONS)
// -----------------------------------------------------------------------------
// This instrumentation records Prebid auction competition and the previous GPT
// render result. It does not delay, cancel, prioritize, or otherwise alter ads.
// A small per-slot history is retained in memory for inspection during a page view.
// The aq_* slot targeting values can also be registered as dynamic GAM keys later.
var AUCTION_QUALITY_HISTORY_LIMIT = 50;

// Tracks recent Prebid wins only for passive source classification.
// This has no effect on auctions, targeting decisions, or refresh cadence.
var auctionQualityRecentPrebidWinsByAdUnit = {};

pbjs.que.push(function () {
    if (window.__zenaAuctionQualityBidWonListenerInstalled) return;
    window.__zenaAuctionQualityBidWonListenerInstalled = true;

    if (typeof pbjs.onEvent === "function") {
        pbjs.onEvent("bidWon", function (bid) {
            try {
                var adUnitCode = bid && bid.adUnitCode;
                if (!adUnitCode) return;
                auctionQualityRecentPrebidWinsByAdUnit[adUnitCode] = {
                    timestamp: Date.now(),
                    bidder: bid.bidder || bid.bidderCode || null,
                    cpm: Number(bid.cpm || 0),
                    adId: bid.adId || null,
                    auctionId: bid.auctionId || null
                };
            } catch (error) {
                adsDebugLog("[auction-quality] bidWon_capture_failed", String(error));
            }
        });
    }
});

function getAuctionQualityCountBucket(count) {
    count = Number(count) || 0;
    if (count <= 0) return "0";
    if (count === 1) return "1";
    if (count === 2) return "2";
    if (count === 3) return "3";
    if (count === 4) return "4";
    return "5plus";
}

function getAuctionQualityTopBidBucket(cpm) {
    cpm = Number(cpm) || 0;
    if (cpm <= 0) return "no_bid";
    if (cpm < 0.10) return "lt_010";
    if (cpm < 0.20) return "010_019";
    if (cpm < 0.50) return "020_049";
    if (cpm < 1.00) return "050_099";
    return "100_plus";
}

function getAuctionQualityPreviousFill(previousRenderResult) {
    if (!previousRenderResult) return "unknown";
    return previousRenderResult.isEmpty ? "unfilled" : "filled";
}

function getAuctionQualityPreviousSource(previousRenderResult) {
    if (!previousRenderResult) return "unknown";
    if (previousRenderResult.isEmpty) return "unfilled";
    if (previousRenderResult.source === "prebid") return "prebid";
    return "gam";
}

function collectAuctionQuality(divId, bidResponses, timedOut, auctionId) {
    var state = getOrCreateRefreshState(divId);
    var bids = [];

    try {
        var slotResponse = bidResponses && bidResponses[divId];
        if (slotResponse && Array.isArray(slotResponse.bids)) {
            bids = slotResponse.bids.filter(function (bid) {
                return bid && Number(bid.cpm) >= 0;
            });
        }
    } catch (error) {
        bids = [];
    }

    var topBid = null;
    bids.forEach(function (bid) {
        if (!topBid || Number(bid.cpm || 0) > Number(topBid.cpm || 0)) {
            topBid = bid;
        }
    });

    var bidderNames = [];
    bids.forEach(function (bid) {
        var bidderName = bid.bidder || bid.bidderCode;
        if (bidderName && bidderNames.indexOf(bidderName) === -1) {
            bidderNames.push(bidderName);
        }
    });

    var now = Date.now();
    var quality = {
        timestamp: now,
        auctionId: auctionId || null,
        divId: divId,
        refreshCountBeforeRequest: Number(state.currentRefreshCount || 0),
        refreshBucketBeforeRequest: getRefreshBucket(Number(state.currentRefreshCount || 0)),
        timeSinceLastRefreshMs: state.lastRefreshTimestamp ? (now - state.lastRefreshTimestamp) : null,
        validBidCount: bids.length,
        bidderCount: bidderNames.length,
        bidderNames: bidderNames,
        highestBidCpm: topBid ? Number(topBid.cpm || 0) : 0,
        highestBidder: topBid ? (topBid.bidder || topBid.bidderCode || null) : null,
        timedOut: Boolean(timedOut),
        previousRenderResult: state.lastRenderResult || null
    };

    state.lastAuctionQuality = quality;
    state.auctionQualityHistory.push(quality);
    if (state.auctionQualityHistory.length > AUCTION_QUALITY_HISTORY_LIMIT) {
        state.auctionQualityHistory.shift();
    }

    return quality;
}

function applyAuctionQualityTargeting(gptSlot, quality) {
    if (!gptSlot || !quality) return;
    try {
        gptSlot.setTargeting("aq_bid_count", getAuctionQualityCountBucket(quality.validBidCount));
        gptSlot.setTargeting("aq_bidder_count", getAuctionQualityCountBucket(quality.bidderCount));
        gptSlot.setTargeting("aq_top_bid_bucket", getAuctionQualityTopBidBucket(quality.highestBidCpm));
        gptSlot.setTargeting("aq_timed_out", quality.timedOut ? "yes" : "no");
        gptSlot.setTargeting("aq_prev_fill", getAuctionQualityPreviousFill(quality.previousRenderResult));
        gptSlot.setTargeting("aq_prev_source", getAuctionQualityPreviousSource(quality.previousRenderResult));
    } catch (error) {
        adsDebugLog("[auction-quality] targeting_failed", quality.divId, String(error));
    }
}

window.__zenaAuctionQualitySnapshot = function () {
    var snapshot = {};
    refreshStateByDivId.forEach(function (state, divId) {
        snapshot[divId] = {
            currentRefreshCount: Number(state.currentRefreshCount || 0),
            lastAuctionQuality: state.lastAuctionQuality || null,
            lastRenderResult: state.lastRenderResult || null,
            history: (state.auctionQualityHistory || []).slice()
        };
    });
    try {
        return JSON.parse(JSON.stringify(snapshot));
    } catch (error) {
        return snapshot;
    }
};


    function resolveGptSlotByDivId(allSlots, divId) {
        for (var slotIndex = 0; slotIndex < allSlots.length; slotIndex++) {
            var candidateSlot = allSlots[slotIndex];
            if (
                candidateSlot &&
                candidateSlot.getSlotElementId &&
                candidateSlot.getSlotElementId() === divId
            ) {
                return candidateSlot;
            }
        }
        return null;
    }

    function attemptRefresh(divId) {
        var state = refreshStateByDivId.get(divId);
        if (!state) {
            return;
        }

        // Clear the scheduled id first; we reschedule explicitly below if still eligible.
        state.scheduledRefreshTimeoutId = null;

        // Hard gates.
        if (document.visibilityState !== "visible") {
            adsDebugLog("[ads-refresh]", divId, "skip refresh: tab_hidden");
            state.continuousViewabilityStartTimestamp = null;
            return;
        }

        if (!state.isAboveVisibilityThreshold) {
            adsDebugLog("[ads-refresh]", divId, "skip refresh: below_threshold", { ratio: state.lastIntersectionRatio });
            state.continuousViewabilityStartTimestamp = null;
            return;
        }

        // Defensive throttle: use the same per-slot/per-bucket interval as scheduling.
        var minimumRefreshIntervalMs = getRefreshIntervalSeconds(divId) * 1000;
        if (state.lastRefreshTimestamp && (Date.now() - state.lastRefreshTimestamp) < minimumRefreshIntervalMs) {
            adsDebugLog(
                "[ads-refresh]",
                divId,
                "skip refresh: min_interval",
                { sinceMs: (Date.now() - state.lastRefreshTimestamp), minimumMs: minimumRefreshIntervalMs }
            );
            scheduleRefreshWindowFromNow(divId);
            return;
        }

        // Resolve and refresh inside googletag.cmd to guarantee GPT readiness.
        googletag.cmd.push(function () {
            var allSlots;
            try {
                allSlots = googletag.pubads().getSlots();
            } catch (error) {
                adsDebugLog("[ads-refresh]", divId, "skip refresh: gpt_not_ready");
                scheduleRefreshWindowFromNow(divId);
                return;
            }

            var gptSlot = resolveGptSlotByDivId(allSlots, divId);
            if (!gptSlot) {
                adsDebugLog("[ads-refresh]", divId, "skip refresh: slot_not_found");
                scheduleRefreshWindowFromNow(divId);
                return;
            }

            // Determine current refresh count from slot targeting.
            var refreshCount = 0;
            try {
                var refreshCountTargeting = gptSlot.getTargeting("refresh_count");
                refreshCount = parseInt((refreshCountTargeting && refreshCountTargeting[0]) || "0", 10);
                if (isNaN(refreshCount)) {
                    refreshCount = 0;
                }
            } catch (error) {
                refreshCount = 0;
            }
            state.currentRefreshCount = refreshCount;

            if (typeof MAX_REFRESH_COUNT_PER_SLOT === "number" && MAX_REFRESH_COUNT_PER_SLOT >= 0 && refreshCount >= MAX_REFRESH_COUNT_PER_SLOT) {
                adsDebugLog("[ads-refresh]", divId, "skip refresh: max_refreshes_reached", { refreshCount: refreshCount });
                return;
            }

            // Block refresh for excluded advertisers and excluded ad units (existing behavior).
            var advertiserID;
            try {
                var responseInformation = gptSlot.getResponseInformation && gptSlot.getResponseInformation();
                advertiserID = responseInformation && responseInformation.advertiserId;
            } catch (error) {
                advertiserID = undefined;
            }

            if (GAM_NOREFRESH_ADVERTISER_IDS.includes(advertiserID)) {
                adsDebugLog("[ads-refresh]", divId, "skip refresh: no_refresh_advertiser", { advertiserID: advertiserID });
                scheduleRefreshWindowFromNow(divId);
                return;
            }

            if (GAM_NOREFRESH_ADUNITS.includes(divId)) {
                adsDebugLog("[ads-refresh]", divId, "skip refresh: no_refresh_adunit");
                scheduleRefreshWindowFromNow(divId);
                return;
            }

            // Keep adUnitCodes semantics: this wrapper uses divId as the Prebid ad unit code.
            var adUnitCode = divId;

            pbjs.que.push(function () {
                pbjs.requestBids({
                    timeout: PREBID_TIMEOUT,
                    adUnitCodes: [adUnitCode],
                    bidsBackHandler: function (bidResponses, timedOut, auctionId) {
                        var auctionQuality = collectAuctionQuality(divId, bidResponses, timedOut, auctionId);
                        pbjs.setTargetingForGPTAsync([adUnitCode]);

                        googletag.cmd.push(function () {
                            // Update refresh_count before calling refresh so targeting is present.
                            var nextRefreshCount = refreshCount + 1;
                            state.currentRefreshCount = nextRefreshCount;
                            gptSlot.setTargeting("refresh_count", String(nextRefreshCount));
                            gptSlot.setTargeting("refresh_bucket", getRefreshBucket(nextRefreshCount));
                            applyAuctionQualityTargeting(gptSlot, auctionQuality);

                            adsDebugLog(
                                "[ads-refresh]",
                                divId,
                                "REFRESH",
                                { refreshCount: nextRefreshCount, ratio: state.lastIntersectionRatio }
                            );

                            googletag.pubads().refresh([gptSlot]);
                        });

                        state.lastRefreshTimestamp = Date.now();

                        if (USE_CUMULATIVE_VIEWABILITY_TIMER) {
                        state.cumulativeViewableMs = 0;
                        state.lastAboveThresholdTimestamp = Date.now();
                    }

                    // If the slot is still eligible, schedule the next refresh window from now.
                        scheduleRefreshWindowFromNow(divId);
                    }
                });
            });
        });
    }

    // Track actual viewability percentage.
    // IMPORTANT: isIntersecting only means "some pixels visible". We must use intersectionRatio.
    var viewabilityObserver = new IntersectionObserver(function (viewabilityEntries) {
        viewabilityEntries.forEach(function (viewabilityEntry) {
            var divId = viewabilityEntry.target.id;
            if (!divId) {
                return;
            }

            var state = getOrCreateRefreshState(divId);

            var ratio = viewabilityEntry.intersectionRatio || 0;
            state.lastIntersectionRatio = ratio;

            var isAbove = ratio >= VISIBILITY_PERCENT_FOR_REFRESH;
            var wasAbove = state.isAboveVisibilityThreshold;

            state.isAboveVisibilityThreshold = isAbove;

            // If we cross above threshold, start the refresh window.
            if (isAbove && !wasAbove) {
                if (USE_CUMULATIVE_VIEWABILITY_TIMER) {
                    state.lastAboveThresholdTimestamp = Date.now();
                }
                adsDebugLog("[ads-refresh]", divId, "threshold_enter", { ratio: ratio });
                scheduleRefreshWindowFromNow(divId);
                return;
            }

            // If we drop below threshold, reset timing and cancel any pending refresh.
            if (!isAbove && wasAbove) {
                adsDebugLog("[ads-refresh]", divId, "threshold_exit", { ratio: ratio });
                if (USE_CUMULATIVE_VIEWABILITY_TIMER) {
                    if (state.lastAboveThresholdTimestamp !== null) {
                        state.cumulativeViewableMs = (state.cumulativeViewableMs || 0) + (Date.now() - state.lastAboveThresholdTimestamp);
                        state.lastAboveThresholdTimestamp = null;
                    }
                }
                state.continuousViewabilityStartTimestamp = null;
                clearScheduledRefresh(divId);
                return;
            }

            // If we are above threshold and nothing is scheduled (e.g. after tab resume),
            // ensure we have an active window running.
            if (isAbove && state.scheduledRefreshTimeoutId === null && document.visibilityState === "visible") {
                if (state.continuousViewabilityStartTimestamp === null) {
                    scheduleRefreshWindowFromNow(divId);
                }
            }
        });
    }, { threshold: [0, VISIBILITY_PERCENT_FOR_REFRESH, 1] });

    // Observe all currently-defined GPT slots.
    googletag.pubads().getSlots().forEach(function (slotAd) {
        // 22092026: out-of-page slots (the web interstitial) have no div, are never refreshed
        // and their auto-generated element id contains "/" characters that would make the
        // "#" + divId selector below throw. Skip them before anything else touches them.
        if (slotAd.getOutOfPage && slotAd.getOutOfPage()) {
            return;
        }
        var divId = slotAd.getSlotElementId();
        if (!divId) {
            return;
        }

        // Initialize state eagerly for debugging and for visibilitychange rescheduling.
        getOrCreateRefreshState(divId);

        var viewabilitySlotElements = document.querySelectorAll("#" + divId);
        viewabilitySlotElements.forEach(function (viewabilitySlotElement) {
            viewabilityObserver.observe(viewabilitySlotElement);
        });
    });



}

// -----------------------------------------------------------------------------
// Early wrapper start test
// -----------------------------------------------------------------------------
// Start the ad wrapper as early as possible once the DOM is usable.
// Important: this block is intentionally placed at the END of the file, after
// googletag/pbjs globals, config variables, and runWrapper() are defined.
function startAdsWrapper(reason) {
    if (window.prebidAuctionRun) {
        return;
    }

    window.prebidAuctionRun = true;

    // Telemetry (15092026): when the wrapper started and what triggered it.
    recordFirstRequestMilestone('wrapperStartMs', 'wrapperStartReason', reason);

    try {
        clearTimeout(window.adsLoadTimer);
    } catch (error) {
        // Intentionally ignore cleanup failures.
    }

    try {
        adsDebugLog('Ad Wrapper: Running early because:', reason);
    } catch (error) {
        // Intentionally ignore logging failures.
    }

    // Queue the wrapper until GPT is fully loaded.
    // Starting the wrapper earlier is useful, but runWrapper() also reads
    // googletag.pubads(), so it must not execute before gpt.js has initialized.
    try {
        googletag.cmd.push(function () {
            runWrapper();
        });
    } catch (error) {
        // Last-resort fallback: keep behavior fail-safe instead of throwing.
        window.adsLoadTimer = setTimeout(function () {
            try {
                googletag.cmd.push(function () {
                    runWrapper();
                });
            } catch (innerError) {}
        }, 300);
    }
}

if (document.readyState === 'interactive' || document.readyState === 'complete') {
    startAdsWrapper('document-ready-state');
} else {
    document.addEventListener('DOMContentLoaded', function () {
        startAdsWrapper('domcontentloaded');
    });
}

// Safety fallback only.
window.adsLoadTimer = setTimeout(function () {
    startAdsWrapper('fallback-timeout');
}, 1200);
